<template>
	<div :class="[$t('PageNavigate.classLang'), $t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
		<page-navigate></page-navigate>
		<div id="pageOverLay" @click="pageOverLayClick"></div>
		<section class="section1">
			<div class="section1-bg">
				<div class="topBg"></div>
				<div class="bottomBg"></div>
			</div>
			<div class="section1-bg2 showSection1Bg"></div>
			 <div class="section1-bg2"></div>
      		<div class="section1-bg3"></div>
			<div class="section1BgForBottom"></div>
			<div class="section1-container-top flex justify-between" :class="[[ 'vi' ,'th'].includes($t('common.lang')) ? 'items-center' : 'items-start']">
				<div class="container-left showContainerLeft whiteTitle">
					<h1 class="super_large-80_bold md-title-32_bold word1" v-html="$t('newHome.word3')" :style="{'white-space': [ 'ko' ].includes($t('common.lang')) ?'nowrap':''}"></h1>
					<h2 class="subtitle-20_regular md-body-14_regular word2" v-html="$t('newHome.word4')"></h2>

					<div class="dataList flex">
						<div class="dataBox">
							<div class="data title-32_medium md-title-24_bold">500:1</div>
							<div class="desc body-14_regular md-footnote-regular_12 word3">
								{{ $t('newHome.word5') }}
							</div>
						</div>
						<div class="dataBox">
							<div class="data title-32_medium md-title-24_bold">200+</div>
							<div class="desc body-14_regular md-footnote-regular_12 word4">
								{{ $t('newHome.word6') }}
							</div>
						</div>
						<div class="dataBox">
							<div class="data title-32_medium md-title-24_bold">0.0pips</div>
							<div class="desc body-14_regular md-footnote-regular_12 word5">
								{{ $t('newHome.word7') }}
							</div>
						</div>
					</div>

					<div class="btnList flex items-center justify-start">
						<a :href="signupUrl" target="_blank">
							<div class="btn animateBtn flex justify-center items-center ">
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
								<span class="word14 content-16_medium">{{ $t('newHome.word17') }}</span>
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
							</div>
						</a>
						<a href="/fcb">
							<div class="btn1 flex justify-center items-center content-16_medium box-border word15">
								{{ $t('newHome.word18') }}
							</div>
						</a>
					</div>
				</div>
				<div class="container-left yellowTitle">
					<h2 class="super_large-80_bold md-title-32_bold word12" :style="{'white-space': [ 'ko','cn','jp' ].includes($t('common.lang')) ?'nowrap':''}">
						EBC携手牛津大学<br class="pc"/>举办研讨会第三期
					</h2>
					<h2 class="subtitle-20_regular md-body-14_regular word13">
						像经济学家一样思考，读懂政策的“弦外之音”
					</h2>
					<h3 class="title-24_bold md-content-14_medium">2025 年 11 月 11 日 12:00 (GMT)</h3>
					<div class="btnList">
						<a href="/partners/oxford/">
							<div class="btn animateBtn flex justify-center items-center ">
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
								<span class="word15 content-16_medium">{{ $t('newHome.word18') }}</span>
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
							</div>
						</a>
					</div>
				</div>

				<div class="container-left">
					<h2 class="super_large-80_bold md-title-32_bold word6" v-html="$t('newHome.word8')" :style="{'white-space': [ 'ko' ].includes($t('common.lang')) ?'nowrap':''}">
					</h2>
					<h2 class="subtitle-20_regular md-body-14_regular word13">
						让更多幼儿可以迎来他们的第5个生日
					</h2>
					<div class="btnList">
						<a href="/malaria">
							<div class="btn animateBtn flex justify-center items-center content-16_medium">
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
								<span class="word15 content-16_medium">{{ $t('newHome.word18') }}</span>
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
							</div>
						</a>
					</div>
				</div>
				<div class="container-left">
					<h2 class="super_large-80_bold md-title-32_bold word7" v-html="$t('newHome.word9')">

					</h2>
					<!-- <h2 class="subtitle-20_regular md-body-14_regular word8">
          免费跟随顶尖交易信号，或成为信号方<br class="br">赚最高
          <span class="subtitle-20_medium md-body-14_medium">18%</span>
          年化收益
        </h2> -->
					<div class="tagList">
						<div class="subtitle-20_medium md-body-14_medium word9">{{ $t('newHome.word11') }}</div>
						<div class="subtitle-20_medium md-body-14_medium word10">{{ $t('newHome.word12') }}</div>
						<div class="subtitle-20_medium md-body-14_medium word11">{{ $t('newHome.word13') }}</div>
					</div>
					<div class="btnList">
						<a href="/pay" >
							<div class="btn animateBtn flex justify-center items-center content-16_medium">
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
								<span class="word15 content-16_medium">{{ $t('newHome.word18') }}</span>
								<img src="@/assets/image/newHome/rightArrow.svg" alt="" />
							</div>
						</a>
					</div>
				</div>

				<div class="container-right">
					<div class="section1-swiper swiper-container">
						<div class="swiper-wrapper items-start">
							<div class="swiper-slide slide-1">
								<img class="pc" src="@/assets/image/newHome/section1Swiper1.png" alt="" />
								<img class="mobile" src="@/assets/image/newHome/section1Modelm.png" alt="" />
							</div>
							<div class="swiper-slide slide-4">
								<img src="@/assets/image/newHome/section1Swiper4.png" alt="" />
							</div>
							<div class="swiper-slide slide-2">
								<img src="@/assets/image/newHome/section1Swiper2.png" alt="" />
							</div>
							<div class="swiper-slide slide-3">
								<img src="@/assets/image/newHome/section1Swiper3.png" alt="" />
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="section1-container-bottom flex justify-center items-center">
				<div class="flex justify-center items-center active" @click="section1ContainerBottomClick(0)">
					<img src="@/assets/image/newHome/section1SwiperTab1.png" alt="" />
				</div>
				<div class="flex justify-center items-center" @click="section1ContainerBottomClick(1)">
					<img src="@/assets/image/newHome/section1SwiperTab4.png" alt="" />
				</div>
				<div class="flex justify-center items-center" @click="section1ContainerBottomClick(2)">
					<img src="@/assets/image/newHome/section1SwiperTab2.png" alt="" />
				</div>
				<div class="flex justify-center items-center" @click="section1ContainerBottomClick(3)">
					<img src="@/assets/image/newHome/section1SwiperTab3.png" alt="" />
				</div>

			</div>
			<div class="section1-container-bottom-mobile">
				<div class="active"></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</section>
		<section class="section1-2">
			<div class="pc">
				<div class="section1-2Swiper swiperList flex">

					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word6">{{ $t('newHome.word85') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word7">{{ $t('newHome.word86') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word8">{{ $t('newHome.word87') }}</div>
							<div class="text2">Global Forex Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item word9"><img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word13">{{ $t('newHome.word88') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word1">{{ $t('newHome.word80') }}</div>
							<div class="text2">FollowMe Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word2">{{ $t('newHome.word81') }}</div>
							<div class="text2">BrokersView Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word3">{{ $t('newHome.word82') }}</div>
							<div class="text2">FollowMe Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word4">{{ $t('newHome.word83') }}</div>
							<div class="text2">Forex Brokers Award</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word5">{{ $t('newHome.word84') }}</div>
							<div class="text2">BrokersView Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word10">{{ $t('newHome.word89') }}</div>
							<div class="text2">Best CFD Provider</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word11">{{ $t('newHome.word90') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word12">{{ $t('newHome.word91') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
				</div>
			</div>
			<div class="mobile">
				<div class="section1-2Swiperm1 swiperList flex">
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word6">{{ $t('newHome.word85') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word7">{{ $t('newHome.word86') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word8">{{ $t('newHome.word87') }}</div>
							<div class="text2">Global Forex Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item word9"><img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word13">{{ $t('newHome.word88') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word1">{{ $t('newHome.word80') }}</div>
							<div class="text2">FollowMe Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word2">{{ $t('newHome.word81') }}</div>
							<div class="text2">BrokersView Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word3">{{ $t('newHome.word82') }}</div>
							<div class="text2">FollowMe Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word4">{{ $t('newHome.word83') }}</div>
							<div class="text2">Forex Brokers Award</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
				</div>

				<div class="section1-2Swiperm2 swiperList flex">
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word5">{{ $t('newHome.word84') }}</div>
							<div class="text2">BrokersView Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word10">{{ $t('newHome.word89') }}</div>
							<div class="text2">Best CFD Provider</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word11">{{ $t('newHome.word90') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
					<div class="item">
						<img src="@/assets/image/newHome/section1-2ListLeft.svg" alt="">
						<div class="center">
							<div class="text1 word12">{{ $t('newHome.word91') }}</div>
							<div class="text2">World Finance Awards</div>
						</div>
						<img src="@/assets/image/newHome/section1-2ListRight.svg" alt="">
					</div>
				</div>
			</div>
		</section>
		<!-- 需要“锁定+动画”的区域 -->

		<section id="scene" class="scene section2 pc">
			<div class="sticky-box flex justify-center items-center flex-col">
				<h2 class="hTitle title-48_bold scroll-fade-up word16">{{ $t('newHome.word19') }}</h2>
				<h3 class="hTitle subtitle-20_regular scroll-fade-up word17">
					{{ $t('newHome.word20') }}
				</h3>

				<div id="contentContainer">
					<div class="contentBox contentBg scroll-fade-up " id="contentBox">
						<div class="contentBoxInner flex flex-col items-center ">
							<div class="tabList box-border flex justify-center items-center text-center">
								<div @click="section2PCClick(0,  $t('newHome.word21'))"
									:class="{ active: listIndex == 0 }" class=" cursor-pointer word18">{{
									$t('newHome.word21') }}</div>
								<div @click="section2PCClick(1,  $t('newHome.word22'))"
									:class="{ active: listIndex == 1 }" class="cursor-pointer word19">{{
									$t('newHome.word22') }}</div>
								<div @click="section2PCClick(2,  $t('newHome.word23'))"
									:class="{ active: listIndex == 2 }" class="cursor-pointer word20">{{
									$t('newHome.word23') }}</div>
								<div @click="section2PCClick(3,  $t('newHome.word24'))"
									:class="{ active: listIndex == 3 }" class="cursor-pointer word21">{{
									$t('newHome.word24') }}</div>
								<div @click="section2PCClick(4,  $t('newHome.word25'))"
									:class="{ active: listIndex == 4 }" class="cursor-pointer word22">{{
									$t('newHome.word25') }}</div>
								<!-- <div @click="section2PCClick(5,  '数字资产')"
								:class="{ active: listIndex == 5 }" class="cursor-pointer word22">数字资产</div> -->
							</div>
							<div class="index-section1-list" data-tag-index="0">
								<div class="index-section1-list-thead">
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-th text-left word23">{{ $t('newHome.word26') }}
										</div>
										<div class="index-section1-list-th text-center word24">{{ $t('newHome.word27')
											}}</div>
										<div class="index-section1-list-th text-center  word25">{{ $t('newHome.word28')
											}}</div>
										<div class="index-section1-list-th text-center  word26">{{ $t('newHome.word29')
											}}</div>
										<div class="index-section1-list-th text-center word27">{{ $t('newHome.word30')
											}}</div>
									</div>
								</div>
								<div class="index-section1-list-tbody" id="pcTbody">
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-td flex items-center">
											<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png"
												alt="" />
											<span data-name>欧元/美元</span>
										</div>
										<div data-bid class="index-section1-list-td bid-price-value ">
											-
										</div>
										<div data-ask class="index-section1-list-td ask-price-value ">
											-
										</div>
										<div class="index-section1-list-td spread-value" data-spread>
											-
										</div>
										<div class="index-section1-list-td" data-rules>500:1</div>
									</div>
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-td flex items-center">
											<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png"
												alt="" />
											<span data-name>英镑/美元</span>
										</div>
										<div data-bid class="index-section1-list-td bid-price-value ">
											-
										</div>
										<div data-ask class="index-section1-list-td ask-price-value ">
											-
										</div>
										<div class="index-section1-list-td spread-value" data-spread>
											-
										</div>
										<div class="index-section1-list-td" data-rules>500:1</div>
									</div>
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-td flex items-center">
											<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png"
												alt="" />
											<span data-name>美元/日元</span>
										</div>
										<div data-bid class="index-section1-list-td bid-price-value ">
											-
										</div>
										<div data-ask class="index-section1-list-td ask-price-value ">
											-
										</div>
										<div class="index-section1-list-td spread-value" data-spread>
											-
										</div>
										<div class="index-section1-list-td" data-rules>500:1</div>
									</div>
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-td flex items-center">
											<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png"
												alt="" />
											<span data-name>澳元/美元</span>
										</div>
										<div data-bid class="index-section1-list-td bid-price-value ">
											-
										</div>
										<div data-ask class="index-section1-list-td ask-price-value ">
											-
										</div>
										<div class="index-section1-list-td spread-value" data-spread>
											-
										</div>
										<div class="index-section1-list-td" data-rules>500:1</div>
									</div>
									<div class="index-section1-list-tr flex items-center">
										<div class="index-section1-list-td flex items-center">
											<img data-src="icon" src="@/assets/image/Home/icons/icon_USDCAD.png"
												alt="" />
											<span data-name>美元/加元</span>
										</div>
										<div data-bid class="index-section1-list-td bid-price-value ">
											-
										</div>
										<div data-ask class="index-section1-list-td ask-price-value ">
											-
										</div>
										<div class="index-section1-list-td spread-value" data-spread>
											-
										</div>
										<div class="index-section1-list-td" data-rules>500:1</div>
									</div>
								</div>
								<div class="tab5ShowMes">
											     *数字资产实行分级杠杆机制，持仓量不同杠杆等级不同，<a href="https://support.ebchelp.com/hc/zh-cn/articles/52301718872601-%E6%95%B0%E5%AD%97%E8%B4%A7%E5%B8%81%E5%88%86%E7%BA%A7%E6%9D%A0%E6%9D%86%E4%B8%8E%E9%87%8D%E5%A4%A7%E6%95%B0%E6%8D%AE%E6%9D%A0%E6%9D%86%E8%B0%83%E6%95%B4" target="_blank">点击了解详情。</a> 

								</div>
							</div>
							<a href="/tradingproduct/">
								<div class="bottomPart section2-animateBtn section-animateBtn content-16_medium flex justify-between items-center"
									style="margin-top: 30rem">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
										fill="none">
										<path d="M3.33325 10H16.6666M16.6666 10L11.6666 5M16.6666 10L11.6666 15"
											stroke="white" stroke-width="1.66667" stroke-linecap="round"
											stroke-linejoin="round" />
									</svg>
									<span class="word28">{{ $t('newHome.word31') }}</span>
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
										fill="none">
										<path
											d="M7.07485 5.04079C6.82194 4.80595 6.80713 4.41035 7.04189 4.1574C7.27673 3.9045 7.67232 3.88969 7.92527 4.12445L13.7586 9.54111C13.886 9.65937 13.9584 9.82549 13.9584 9.99928C13.9584 10.1731 13.886 10.3392 13.7586 10.4575L7.92527 15.8741L7.87644 15.9152C7.62372 16.1062 7.26209 16.0783 7.04189 15.8412C6.82181 15.604 6.82096 15.2416 7.03009 15.0038L7.07485 14.9578L12.4146 9.99928L7.07485 5.04079Z"
											fill="white" />
									</svg>
								</div>
							</a>

						</div>

					</div>
				</div>

			</div>
		</section>
		<section class="section2 mobile">
			<h2 class="title-24_bold text-center scroll-fade-up word16">{{ $t('newHome.word19') }}</h2>
			<h3 class="footnote-regular_12 text-center scroll-fade-up word17">
				{{ $t('newHome.word20') }}
			</h3>
			<div class="tab-wrapper">
				<div class="tab-scroll">
					<div @click="section2MobileClick(0)" :class="{ active: listIndex == 0 }"
						class="footnote-medium_12 cursor-pointer tab word18">
						{{ $t('newHome.word21') }}
					</div>
					<div @click="section2MobileClick(1)" :class="{ active: listIndex == 1 }"
						class="footnote-medium_12 cursor-pointer tab word20">{{ $t('newHome.word22') }}</div>
					<div @click="section2MobileClick(2)" :class="{ active: listIndex == 2 }"
						class="footnote-medium_12 cursor-pointer tab word19">{{ $t('newHome.word23') }}</div>
					<div @click="section2MobileClick(3)" :class="{ active: listIndex == 3 }"
						class="footnote-medium_12 cursor-pointer tab word21">{{ $t('newHome.word24') }}</div>
					<div @click="section2MobileClick(4)" :class="{ active: listIndex == 4 }"
						class="footnote-medium_12 cursor-pointer tab word22">{{ $t('newHome.word25') }}</div>
					<!-- <div @click="section2MobileClick(5)" :class="{ active: listIndex == 5 }"
					class="footnote-medium_12 cursor-pointer tab word22">数字资产</div> -->
				</div>
			</div>
			<div id="tbodyContainerM">
			<div class="tableData " id="mobileTbody">
				<div class="table-tr">
					<div class="top flex justify-between items-center">
						<div class="flex items-center">
							<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png" alt="" />
							<span class="desc body-14_medium" data-name>欧元/美元</span>
						</div>
						<div>
							<span class="desc footnote-regular_12 word27">{{ $t('newHome.word30')}}：</span>
							<span class="value body-14_medium" data-rules>500:1</span>
						</div>
					</div>
					<div class="bottom flex justify-between items-center text-center">
						<div>
							<div class="value  body-16_medium" data-bid></div>
							<div class="desc footnote-regular_12 word25">{{ $t('newHome.word27') }}</div>
						</div>
						<div>
							<div data-ask class=" value body-16_medium"></div>
							<div class="desc footnote-regular_12 word26">{{ $t('newHome.word28') }}</div>
						</div>
						<div>
							<div class="value body-16_medium" data-spread>-</div>
							<div class="desc footnote-regular_12 word27">{{ $t('newHome.word29') }}</div>
						</div>
					</div>
				</div>
				<div class="table-tr">
					<div class="top flex justify-between items-center">
						<div class="flex items-center">
							<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png" alt="" />
							<span class="desc body-14_medium" data-name>欧元/美元</span>
						</div>
						<div>
							<span class="desc footnote-regular_12 word27">{{ $t('newHome.word30')}}：</span>
							<span class="value body-14_medium" data-rules>500:1</span>
						</div>
					</div>
					<div class="bottom flex justify-between items-center text-center">
						<div>
							<div class="value  body-16_medium" data-bid></div>
							<div class="desc footnote-regular_12 word25">{{ $t('newHome.word27') }}</div>
						</div>
						<div>
							<div data-ask class=" value body-16_medium"></div>
							<div class="desc footnote-regular_12 word26">{{ $t('newHome.word28') }}</div>
						</div>
						<div>
							<div class="value body-16_medium" data-spread>-</div>
							<div class="desc footnote-regular_12 word27">{{ $t('newHome.word29') }}</div>
						</div>
					</div>
				</div>
				<div class="table-tr">
					<div class="top flex justify-between items-center">
						<div class="flex items-center">
							<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png" alt="" />
							<span class="desc body-14_medium" data-name>欧元/美元</span>
						</div>
						<div>
							<span class="desc footnote-regular_12 word27">{{ $t('newHome.word30')}}：</span>
							<span class="value body-14_medium" data-rules>500:1</span>
						</div>
					</div>
					<div class="bottom flex justify-between items-center text-center">
						<div>
							<div class="value  body-16_medium" data-bid></div>
							<div class="desc footnote-regular_12 word25">{{ $t('newHome.word27') }}</div>
						</div>
						<div>
							<div data-ask class=" value body-16_medium"></div>
							<div class="desc footnote-regular_12 word26">{{ $t('newHome.word28') }}</div>
						</div>
						<div>
							<div class="value body-16_medium" data-spread>-</div>
							<div class="desc footnote-regular_12 word27">{{ $t('newHome.word29') }}</div>
						</div>
					</div>
				</div>
				<div class="table-tr">
					<div class="top flex justify-between items-center">
						<div class="flex items-center">
							<img data-src="icon" src="@/assets/image/Home/icons/icon_EURUSD.png" alt="" />
							<span class="desc body-14_medium" data-name>欧元/美元</span>
						</div>
						<div>
							<span class="desc footnote-regular_12 word27">{{ $t('newHome.word30')}}：</span>
							<span class="value body-14_medium" data-rules>500:1</span>
						</div>
					</div>
					<div class="bottom flex justify-between items-center text-center">
						<div>
							<div class="value  body-16_medium" data-bid></div>
							<div class="desc footnote-regular_12 word25">{{ $t('newHome.word27') }}</div>
						</div>
						<div>
							<div data-ask class=" value body-16_medium"></div>
							<div class="desc footnote-regular_12 word26">{{ $t('newHome.word28') }}</div>
						</div>
						<div>
							<div class="value body-16_medium" data-spread>-</div>
							<div class="desc footnote-regular_12 word27">{{ $t('newHome.word29') }}</div>
						</div>
					</div>
				</div>
				<div class="table-tr">
					<div class="top flex justify-between items-center">
						<div class="flex items-center">
							<img data-src="icon" src="@/assets/image/Home/icons/icon_USDCAD.png" alt="" />
							<span class="desc body-14_medium" data-name>美元/加元</span>
						</div>
						<div>
							<span class="desc footnote-regular_12 word27">{{ $t('newHome.word30')}}：</span>
							<span class="value body-14_medium" data-rules>500:1</span>
						</div>
					</div>
					<div class="bottom flex justify-between items-center text-center">
						<div>
							<div class="value  body-16_medium" data-bid></div>
							<div class="desc footnote-regular_12 word25">{{ $t('newHome.word27') }}</div>
						</div>
						<div>
							<div data-ask class=" value body-16_medium"></div>
							<div class="desc footnote-regular_12 word26">{{ $t('newHome.word28') }}</div>
						</div>
						<div>
							<div class="value body-16_medium" data-spread>-</div>
							<div class="desc footnote-regular_12 word27">{{ $t('newHome.word29') }}</div>
						</div>
					</div>
				</div>
			</div>
			 <div class="tab5ShowMes">
			     *数字资产实行分级杠杆机制，持仓量不同杠杆等级不同，<a href="https://support.ebchelp.com/hc/zh-cn/articles/52301718872601-%E6%95%B0%E5%AD%97%E8%B4%A7%E5%B8%81%E5%88%86%E7%BA%A7%E6%9D%A0%E6%9D%86%E4%B8%8E%E9%87%8D%E5%A4%A7%E6%95%B0%E6%8D%AE%E6%9D%A0%E6%9D%86%E8%B0%83%E6%95%B4" target="_blank">点击了解详情。</a> 
            </div>
			</div>
			<a href="/tradingproduct/ " target="_blank">
				<div class="bottomBtn body-14_medium flex items-center justify-center">
					<span class="word28">{{ $t('newHome.word31') }}</span>
					<img src="@/assets/image/newHome/rightArrow2.svg" alt="">
				</div>
			</a>
		</section>
		<section class="section3">
			<div class="section3Container">
				<h2 class="title-48_bold scroll-fade-up text-center md-title-24_bold word37">{{ $t('newHome.word40') }}
				</h2>
				<h3 class="subtitle-20_regular scroll-fade-up text-center md-footnote-regular_12 word38">
					{{ $t('newHome.word41') }}</h3>
				<div class="cardBox flex justify-center items-center">
					<div class="left flex flex-col ">
						<div class="card card1 flip-box  scroll-fade-left">
							<div class="flipper " @click="flipBoxClick">
								<div class="front box-border">
									<h4 class="title-24_bold md-subtitle-18_medium word39">{{ $t('newHome.word42') }}</h4>
									<div class="logoList flex flex-wrap ">
										<div class="item flex justify-center items-center">
											<a href="https://ebcfin.pro/LearningCenterInfo?id=LEARN-196-367" target="_blank">
												<img src="@/assets/image/newHome/section3Card1logo1.png" alt="">
											</a>
										</div>
										<div class="item flex justify-center items-center">
											<a href="https://ebcfin.pro/LearningCenterInfo?id=LEARN-770-2FF " target="_blank">
												<img src="@/assets/image/newHome/section3Card1logo2.png" alt="">
											</a>
										</div>
										<div class="item flex justify-center items-center">
											<a href="https://ebcfin.pro/LearningCenterInfo?id=LEARN-2C9" target="_blank">
												<img src="@/assets/image/newHome/section3Card1logo3.png" alt="">
											</a>
										</div>
										<div class="item flex justify-center items-center card1Logo4">
											<a href="https://ebcfin.pro/LearningCenterInfo?id=LEARN-369-368" target="_blank">
												<img src="@/assets/image/newHome/section3Card1logo4.png" alt="">
											</a>
										</div>
									</div>
									<img class="rightIcon cursor-pointer"
										src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">
								</div>
								<div class="back box-border flex flex-col justify-center ">
									<h4 class="title-24_bold md-subtitle-18_medium word39">{{ $t('newHome.word42') }}</h4>
									<article class="content-16_regular md-content-14_regular word40">
										{{ $t('newHome.word43') }}
									</article>
									<img class="rightIcon cursor-pointer"
										src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">

								</div>
							</div>

						</div>
						<div class="card card2 flip-box  scroll-fade-left">
							<div class="flipper" @click="flipBoxClick">
								<div class="front box-border">
									<h4 class="title-24_bold md-subtitle-18_medium word41">{{ $t('newHome.word44') }}
									</h4>
									<div class="brandList pc">
										<div class="brandListLine flex flex-nowrap">
											<div></div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon1.png" alt="">
											</div>
											<div class="flex justify-center items-center">
												<a href="/malaria">
													<img src="@/assets/image/newHome/section3Card2BrandIcon2.svg"
														alt="">
												</a>
											</div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon3.png" alt="">
											</div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon4.png" alt="">
											</div>
											<div></div>
										</div>
										<div class="brandListLine flex flex-nowrap">
											<div></div>
											<div class="flex justify-center items-center">
											</div>
											<div class="flex justify-center items-center">
												<a href="n/partners/oxford/">
													<img src="@/assets/image/newHome/section3Card2BrandIcon6.png"
														alt="">
												</a>
											</div>
											<div class="flex justify-center items-center">
												<a href="/fcb">
													<img src="@/assets/image/newHome/section3Card2BrandIcon7.png"
														alt="">
												</a>
											</div>
											
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon9.png" alt="">
											</div>
											<div></div>
											<div></div>
										</div>
									</div>
									<div class="brandList mobile">
										<div class="brandListLine flex flex-nowrap">
											<div></div>
											<div class="flex justify-center items-center"> 
											</div>
											<div class="flex justify-center items-center">
												<a href="/malaria  " target="_blank">
													<img src="@/assets/image/newHome/section3Card2BrandIcon2.svg"
														alt="">
												</a>
											</div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon3.png" alt="">
											</div>
											<div></div>
											<div></div>
										</div>
										<div class="brandListLine flex flex-nowrap">
											<div></div>
											<div class="flex justify-center items-center">
												<img
													src="@/assets/image/newHome/section3Card2BrandIcon1.png" alt="">
											</div>
											<div class="flex justify-center items-center">
												<a href="/fcb">
													<img src="@/assets/image/newHome/section3Card2BrandIcon7.png"
														alt="">
												</a>
											</div>
											<div class="flex justify-center items-center">
												<a href="/partners/oxford/">
													<img src="@/assets/image/newHome/section3Card2BrandIcon6.png"
														alt="">
												</a>
											</div>
											<div></div>
										</div>
										<div class="brandListLine flex flex-nowrap">
											<div></div>
											<div class="flex justify-center items-center">
											</div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon9.png" alt="">
											</div>
											<div class="flex justify-center items-center"> <img
													src="@/assets/image/newHome/section3Card2BrandIcon4.png" alt="">
											</div>
											<div></div>
											<div></div>
										</div>
									</div>
									<img class="rightIcon cursor-pointer"
										src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">

								</div>
								<div class="back box-border flex flex-col justify-center ">
									<h4 class="title-24_bold md-subtitle-18_medium word41">{{ $t('newHome.word44') }}
									</h4>
									<article class="content-16_regular md-content-14_regular word42">
										{{ $t('newHome.word45') }}</article>
									<img class="rightIcon cursor-pointer"
										src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">


								</div>
							</div>


						</div>
					</div>
					<div class="right flex flex-col ">
						<div class="card card3 flip-box scroll-fade-right">
							<div class="flipper " @click="flipBoxClick">
								<div class="front box-border">
									<h4 class="title-24_bold md-subtitle-18_medium word43">{{ $t('newHome.word46') }}
									</h4>
									<img class="rightIcon cursor-pointer"
										src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">

									<img src="@/assets/image/newHome/section3Card3Topbg.png" alt="" class="rightTopBg">
									<div class="jgList">
										<div class="flex items-center jgItem" v-if="$i18n.locale !='ja'">
											<img src="@/assets/image/newHome/section3Card3Icon1.png" alt="">
											<div>
												<a href="https://register.fca.org.uk/s/firm?id=0014G00002Vq7yNQAR "
													target="_blank">
													<div class="title subtitle-20_medium md-body-14_medium">
														{{ $t('newHome.word47') }}
														<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10"
															viewBox="0 0 6 10" fill="none">
															<path d="M1 1L5 5L1 9" stroke="black"
																stroke-opacity="0.64" />
														</svg>
													</div>
												</a>
												<div class="desc desc1 body-14_regular md-footnote-regular_12">{{
													$t('newHome.word48') }}</div>
												<div class="desc desc2 body-14_regular md-footnote-regular_12">
													{{ $t('newHome.word49') }}</div>
												<div class="desc desc3 body-14_regular md-footnote-regular_12">{{
													$t('newHome.word50') }}
												</div>
											</div>
										</div>
										<div class="flex items-center jgItem">
											<img src="@/assets/image/newHome/section3Card3Icon2.png" alt="">
											<div>
												<a href=" https://www.cima.ky/search-entities-cima "
													target="_blank">
													<div class="title subtitle-20_medium md-body-14_medium">{{
														$t('newHome.word51') }}
														<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10"
															viewBox="0 0 6 10" fill="none">
															<path d="M1 1L5 5L1 9" stroke="black"
																stroke-opacity="0.64" />
														</svg>
													</div>
												</a>
												<div class="desc desc1 body-14_regular md-footnote-regular_12">{{
													$t('newHome.word52') }}</div>
												<div class="desc desc2 body-14_regular md-footnote-regular_12">
													{{ $t('newHome.word53') }}</div>
												<div class="desc desc3 body-14_regular md-footnote-regular_12">{{
													$t('newHome.word54') }}</div>
											</div>

										</div>
										<div class="flex items-center jgItem" v-if="$i18n.locale !='ja'">
										<img src="@/assets/image/newHome/section3Card3Icon3.png" alt="">

										<div>
											<a href="https://service.asic.gov.au/search/" target="_blank">
												<div class="title subtitle-20_medium md-body-14_medium">{{
													$t('newHome.word55') }}
													<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10"
														viewBox="0 0 6 10" fill="none">
														<path d="M1 1L5 5L1 9" stroke="black" stroke-opacity="0.64" />
													</svg>
												</div>
											</a>
											<div class="desc desc1 body-14_regular md-footnote-regular_12">EBC
												{{ $t('newHome.word56') }}</div>
											<div class="desc desc2 body-14_regular md-footnote-regular_12">
												{{ $t('newHome.word57') }}</div>
											<div class="desc desc3 body-14_regular md-footnote-regular_12">{{
												$t('newHome.word58') }}
											</div>
										</div>
									</div>
									</div>
									
								</div>
							<div class="back box-border flex flex-col justify-center ">
								<h4 class="title-24_bold md-subtitle-18_medium word43">{{ $t('newHome.word46') }}</h4>
								<article class="content-16_regular md-content-14_regular">
									{{ $t('newHome.word59') }} </article>
								<article class="content-16_regular md-content-14_regular">
									{{ $t('newHome.word60')}} </article>
								<article class="content-16_regular md-content-14_regular">
									{{ $t('newHome.word61') }}
								</article>
								<img class="rightIcon cursor-pointer"
									src="@/assets/image/newHome/section3CardRightIconm.svg" alt="">

							</div>

						</div>
					</div>
				</div>
			</div>
			<a href="/security">
				<div class="mobile">
					<div class="btn body-14_medium flex justify-center items-center ">
						<span class="word15  body-14_medium">{{ $t('newHome.word18') }}</span> <img
							src="@/assets/image/newHome/rightArrow2.svg" alt="">
					</div>
				</div>
				<div class="pc">
					<div
						class="bottomPart section-animateBtn scroll-fade-up content-16_medium flex justify-between items-center ">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M3.33325 10H16.6666M16.6666 10L11.6666 5M16.6666 10L11.6666 15" stroke="white"
								stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<span class="word15 content-16_medium">{{ $t('newHome.word18') }}</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path
								d="M7.07485 5.04079C6.82194 4.80595 6.80713 4.41035 7.04189 4.1574C7.27673 3.9045 7.67232 3.88969 7.92527 4.12445L13.7586 9.54111C13.886 9.65937 13.9584 9.82549 13.9584 9.99928C13.9584 10.1731 13.886 10.3392 13.7586 10.4575L7.92527 15.8741L7.87644 15.9152C7.62372 16.1062 7.26209 16.0783 7.04189 15.8412C6.82181 15.604 6.82096 15.2416 7.03009 15.0038L7.07485 14.9578L12.4146 9.99928L7.07485 5.04079Z"
								fill="white" />
						</svg>
					</div>
				</div>
			</a>
			</div>
		</section>
		<section class="section2-2 mobile">
			<h2 class="title-24_bold text-center scroll-fade-up word29">{{ $t('newHome.word32') }}</h2>
			<h3 class="footnote-regular_12 text-center scroll-fade-up word30">
				{{ $t('newHome.word33') }}</h3>
			<div class="location" id="locationEleM">
				<img src="@/assets/image/newHome/section2Locationm.png" alt="" />
				<div id="section2Point" @click="showComfirmPopover">
					<div class="ring"></div>
					<div class="dot"></div>
				</div>
				<div class="section2ConfirmPopover box-border ">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
						class="closeBtn" @click="section2ConfirmPopoverClose">
						<path
							d="M17.4656 5.46963C17.7585 5.17676 18.2333 5.17682 18.5262 5.46963C18.8191 5.76252 18.8191 6.23728 18.5262 6.53017L13.0565 11.9999L18.5262 17.4696L18.5779 17.5267C18.818 17.8213 18.8007 18.2556 18.5262 18.5301C18.2517 18.8046 17.8173 18.8219 17.5228 18.5819L17.4656 18.5301L11.9959 13.0604L6.52621 18.5301C6.23331 18.8229 5.75853 18.823 5.46567 18.5301C5.17289 18.2373 5.17291 17.7625 5.46567 17.4696L10.9354 11.9999L5.46567 6.53017C5.17289 6.23731 5.17291 5.7625 5.46567 5.46963C5.75854 5.17676 6.23332 5.17682 6.52621 5.46963L11.9959 10.9393L17.4656 5.46963Z"
							fill="black" />
					</svg>
					<div class="body-14_regular word text-center word35">{{ $t('newHome.word38') }}</div>
					<a :href="signupUrl" target="_blank">
					<div class="btn body-14_medium flex justify-center items-center">
						<span class="word36 body-14_medium">{{ $t('newHome.word39') }}</span>
						<img src="@/assets/image/newHome/rightArrow2.svg" alt="">
					</div>
					</a>
				</div>
				<div class="topWord footnote-regular_12">{{ $t('newHome.word77') }}</div>
				<div class="rightWord footnote-regular_12">{{ $t('newHome.word78') }}</div>
				<canvas id="pointCanvasM" width="550" height="400"></canvas>
			</div>
			<div class="locationBottom flex justify-center items-center">
				<div class="flex items-center">
					<div class="spot"></div>
					<div class="footnote-regular_12">EBC</div>
				</div>
				<div class="flex items-center">
					<div class="spot"></div>
					<div class="footnote-regular_12">{{ $t('newHome.word79') }}</div>
				</div>
			</div>
			<div class="dataList grid ">
				<div class="dataItem col-6">
					<div class="topNum title-24_bold text-center"><span id="number5m">1000</span>+</div>
					<div class="bottomDesc footnote-regular_12 text-center word31">{{ $t('newHome.word34') }}</div>
				</div>
				<div class="dataItem col-6">
					<div class="topNum title-24_bold text-center"><span id="number6m">20</span>ms</div>
					<div class="bottomDesc footnote-regular_12 text-center word32">{{ $t('newHome.word35') }}</div>
				</div>
				<div class="dataItem col-6">
					<div class="topNum title-24_bold text-center"><span id="number7m">98.75</span>%</div>
					<div class="bottomDesc footnote-regular_12 text-center word33">{{ $t('newHome.word36') }}</div>
				</div>
				<div class="dataItem col-6">
					<div class="topNum title-24_bold text-center"><span id="number8m">0.0</span>pips</div>
					<div class="bottomDesc footnote-regular_12 text-center word34">{{ $t('newHome.word37') }}</div>
				</div>
			</div>
			<a :href="signupUrl" target="_blank">
				<div class="btn body-14_medium flex justify-center items-center">
					<span class="word36 body-14_medium">{{ $t('newHome.word39') }}</span>
					<img src="@/assets/image/newHome/rightArrow2.svg" alt="">
				</div>
			</a>
		</section>
		<section class="scene2 pc">
			<div class="scene2Container">
				<h2 class="hTitle2 title-48_bold word29 scroll-fade-up">{{ $t('newHome.word32') }}</h2>
				<h3 class="hTitle2 subtitle-20_regular word30 scroll-fade-up">
					{{ $t('newHome.word33') }}
				</h3>
				<div class="flex justify-center items-center">
					<div class="leftPart">
						<div class="contentBoxStep2 text-right scroll-fade-left">
							<div><span id="number5"></span>+</div>
							<div class="body-14_regular word31">{{ $t('newHome.word34') }}</div>
						</div>
						<div class="contentBoxStep2 text-right scroll-fade-left">
							<div><span id="number6"></span>ms</div>
							<div class="body-14_regular word32">{{ $t('newHome.word35') }}</div>
						</div>
					</div>
					<div class="location box-border scroll-fade-up " id="locationEle">
						<div class="locationContainer ">
							<img src="@/assets/image/newHome/section2Location.png" alt="" />
							<div id="section2PointPC" class="cursor-pointer">
								<div class="ring"></div>
								<div class="dot"></div>
								<div
									class="locationHoverBox box-border flex flex-col justify-between items-center text-center">
									<div class="word35">
										{{ $t('newHome.word38') }}
									</div>
									<a :href="signupUrl" target="_blank">
										<div class="animateBtn flex justify-center items-center cursor-pointer word36">
											{{ $t('newHome.word39') }}</div>
									</a>
								</div>
							</div>
							<div class="pointCanvasContainer">
								<canvas id="pointCanvas" width="425" height="307"></canvas>
								<div class="locationY footnote-regular_12">{{ $t('newHome.word77') }}</div>
								<div class="locationX footnote-regular_12">{{ $t('newHome.word78') }}</div>
								<div class="canvasLegend flex justify-center items-center">
									<div class="flex items-center">
										<div class="point"></div>
										<div class="desc">EBC</div>
									</div>
									<div class="flex items-center">
										<div class="point"></div>
										<div class="desc">{{ $t('newHome.word79') }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="rightPart">
						<div class="contentBoxStep2 text-left scroll-fade-right">
							<div><span id="number7"></span>%</div>
							<div class="body-14_regular word33">{{ $t('newHome.word36') }}</div>
						</div>
						<div class="contentBoxStep2 text-left scroll-fade-right">
							<div><span id="number8"></span>pips</div>
							<div class="body-14_regular word34">{{ $t('newHome.word37') }}</div>
						</div>
					</div>
				</div>
				<a :href="signupUrl" target="_blank">
					<div
						class="bottomPart section2-animateBtn section-animateBtn scroll-fade-up content-16_medium flex justify-between items-center">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M3.33325 10H16.6666M16.6666 10L11.6666 5M16.6666 10L11.6666 15" stroke="white"
								stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<span class="word36 content-16_medium">{{ $t('newHome.word39') }}</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path
								d="M7.07485 5.04079C6.82194 4.80595 6.80713 4.41035 7.04189 4.1574C7.27673 3.9045 7.67232 3.88969 7.92527 4.12445L13.7586 9.54111C13.886 9.65937 13.9584 9.82549 13.9584 9.99928C13.9584 10.1731 13.886 10.3392 13.7586 10.4575L7.92527 15.8741L7.87644 15.9152C7.62372 16.1062 7.26209 16.0783 7.04189 15.8412C6.82181 15.604 6.82096 15.2416 7.03009 15.0038L7.07485 14.9578L12.4146 9.99928L7.07485 5.04079Z"
								fill="white" />
						</svg>
					</div>
				</a>
			</div>
		</section>
		<section class="section4" id="earthShow">
			<h2 class="text-center scroll-fade-up title-48_bold md-title-24_bold word48">{{ $t('newHome.word62') }}</h2>
			<h3 class="text-center scroll-fade-up subtitle-20_regular md-footnote-regular_12 word49">
				{{ $t('newHome.word63') }}</h3>
			<div class="section4Bottom flex justify-center items-start scroll-fade-up">
				<div class="text-center">
					<div class="top title-48_bold md-title-24_bold flex items-center justify-center">$<span
							id="section4number1">2760</span><span class="danwei">亿</span>+</div>
					<div class="bottom body-16_regular md-footnote-regular_12 word50">{{ $t('newHome.word64') }}</div>
				</div>
				<div class="text-center">
					<div class="top title-48_bold md-title-24_bold flex items-center justify-center"><span
							id="section4number2">800</span><span class="danwei">万</span>+</div>
					<div class="bottom body-16_regular md-footnote-regular_12 word51">{{ $t('newHome.word65') }}</div>
				</div>
				<div class="text-center">
					<div class="top title-48_bold md-title-24_bold"><span id="section4number3">87.6</span>%</div>
					<div class="bottom body-16_regular md-footnote-regular_12 word52">{{ $t('newHome.word66') }}</div>
				</div>
				<div class="text-center">
					<div class="top title-48_bold md-title-24_bold"><span id="section4number4">100</span>+</div>
					<div class="bottom body-16_regular md-footnote-regular_12 word53">{{ $t('newHome.word67') }}</div>
				</div>
			</div>
			<div class="section4Tip footnote-regular_12 scroll-fade-up">
      *数据统计截止至2025年10月31日
    </div>
			<div class="container">
				<div id="overlay"></div>
				<div id="earth-container"></div>
			</div>

			<div class="mobile">
				<div class="btn body-14_medium flex justify-center items-center" id="section4ContactUs"
					@click="showFormPopup"><span class="word54 body-14_medium">与我们见面</span> <img
						src="@/assets/image/newHome/section4BtnIconm.svg" alt="">
				</div>
			</div>
			<div class="formPopup box-border">
				<span class="formPopupClose">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
						<g clip-path="url(#clip0_4123_9841)">
							<path
								d="M23.2893 7.29284C23.6798 6.90235 24.3128 6.90242 24.7034 7.29284C25.0939 7.68336 25.0939 8.31637 24.7034 8.7069L17.4104 15.9999L24.7034 23.2928L24.7724 23.369C25.0925 23.7617 25.0694 24.3408 24.7034 24.7069C24.3374 25.0727 23.7582 25.0959 23.3655 24.7759L23.2893 24.7069L15.9964 17.4139L8.70341 24.7069C8.31287 25.0972 7.67983 25.0973 7.28935 24.7069C6.89898 24.3164 6.899 23.6833 7.28935 23.2928L14.5823 15.9999L7.28935 8.7069C6.89898 8.31641 6.899 7.68334 7.28935 7.29284C7.67984 6.90235 8.31288 6.90242 8.70341 7.29284L15.9964 14.5858L23.2893 7.29284Z"
								fill="black" fill-opacity="0.48" />
						</g>
						<defs>
							<clipPath id="clip0_4123_9841">
								<rect width="32" height="32" fill="white" />
							</clipPath>
						</defs>
					</svg>
				</span>
				<h3 class="title-32_bold md-title-24_bold word60">{{ $t('newHome.word74') }}</h3>
				<h4 class="body-16_regular md-footnote-regular_12 word61">{{ $t('newHome.word75') }}</h4>
				<input class="body-14_regular box-border" id="formName" type="text"
					:placeholder=" $t('newHome.word93')">
				<input class="body-14_regular box-border" id="formEmail" type="text"
					:placeholder=" $t('newHome.word94')">
				<input class="body-14_regular box-border" id="formTel" type="text" :placeholder=" $t('newHome.word95')">
				<div class="verify flex justify-center">
					<input class="body-14_regular box-border" id="formVerify" type="text"
						:placeholder=" $t('newHome.word96')">
					<div class="verify-img" @click="refreshCode">
						<ss-code :identifyCode="identifyCode"></ss-code>
					</div>
				</div>
				<div id="form-submit"
					class="btn body-16_medium flex justify-center items-center md-content-16_medium word62">{{
					$t('newHome.word76') }}</div>
			</div>
		</section>
		<page-footer></page-footer>
	</div>
</template>

<script>
import seamscroll from '../assets/js/seamless.min.js'
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import { locale } from 'vue-i18n';
import md5 from 'js-md5';
import $ from 'jquery';
import THREE from '../assets/js/globe.js';
import TWEEN from '../assets/js/tween.umd.js';
import acternityUMD from '../assets/js/acternityUMD.umd.cjs';
import { mapGetters } from 'vuex';
let listE = [
	{
		displaySymbol: "EURUSD",
		length: 5,
	},
	{
		displaySymbol: "GBPUSD",
		length: 5,
	},
	{
		displaySymbol: "USDJPY",
		length: 3,
	},
	{
		displaySymbol: "AUDUSD",
		length: 5,
	},
	{
		displaySymbol: "XAUUSD",
		length: 2,
	},
	{
		displaySymbol: "XAGUSD",
		length: 3,
	},
	{
		displaySymbol: "XBRUSD",
		length: 3,
	},
	{
		displaySymbol: "XNGUSD",
		length: 4,
	},
	{
		displaySymbol: "U30USD",
		length: 1,
	},
	{
		displaySymbol: "NASUSD",
		length: 1,
	},
	{
		displaySymbol: "SPXUSD",
		length: 2,
	},
	{
		displaySymbol: "D30EUR",
		length: 1,
	},
	{
		displaySymbol: "AAPL",
		length: 2,
	},
	{
		displaySymbol: "TSLA",
		length: 2,
	},
	{
		displaySymbol: "AMZN",
		length: 2,
	},
	{
		displaySymbol: "MSFT",
		length: 2,
	},
	{
		displaySymbol: "SPY",
		length: 2,
	},
	{
		displaySymbol: "VOO",
		length: 2,
	},
	{
		displaySymbol: "IVV",
		length: 2,
	},
	{
		displaySymbol: "VTI",
		length: 2,
	},
]
let allProducts = [
  {
    displaySymbol: "EURUSD",
    displaySymbolZh: "欧元/美元",
    displaySymbolTw: "歐元/美元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Forex",
    listIndex: 0,
  },
  {
    displaySymbol: "GBPUSD",
    displaySymbolZh: "英镑/美元",
    displaySymbolTw: "英鎊/美元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Forex",
    listIndex: 0,
  },
  {
    displaySymbol: "USDJPY",
    displaySymbolZh: "美元/日元",
    displaySymbolTw: "美元/日圓",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Forex",
    listIndex: 0,
  },
  {
    displaySymbol: "AUDUSD",
    displaySymbolZh: "澳元/美元",
    displaySymbolTw: "澳幣/美元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Forex",
    listIndex: 0,
  },
  {
    displaySymbol: "USDCAD",
    displaySymbolZh: "美元/加元",
    displaySymbolTw: "美元/加元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Forex",
    listIndex: 0,
  },
  {
    displaySymbol: "XAUUSD",
    displaySymbolZh: "黄金/美元 ",
    displaySymbolTw: "黃金/美元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Commodities",
    listIndex: 1,
  },
  {
    displaySymbol: "XAGUSD",
    displaySymbolZh: "白银/美元",
    displaySymbolTw: "白銀/美元",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Commodities",
    listIndex: 1,
  },
  {
    displaySymbol: "XBRUSD",
    displaySymbolZh: "布伦特原油",
    displaySymbolTw: "布蘭特原油",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Commodities",
    listIndex: 1,
  },
  {
    displaySymbol: "XTIUSD",
    displaySymbolZh: "WTI原油",
    displaySymbolTw: "WTI原油",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Commodities",
    listIndex: 1,
  }, 
  {
    displaySymbol: "XNGUSD",
    displaySymbolZh: "天然气",
    displaySymbolTw: "天然氣",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "Commodities",
    listIndex: 1,
  },
  {
    displaySymbol: "U30USD",
    displaySymbolZh: "道琼斯指数",
    displaySymbolTw: "道瓊斯指數",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "IndexCFDs",
    listIndex: 2,
  },
  {
    displaySymbol: "NASUSD",
    displaySymbolZh: "纳斯达克指数",
    displaySymbolTw: "納斯達克指數",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "IndexCFDs",
    listIndex: 2,
  },
  {
    displaySymbol: "SPXUSD",
    displaySymbolZh: "标普500指数 ",
    displaySymbolTw: "標普500指數",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "IndexCFDs",
    listIndex: 2,
  },
  {
    displaySymbol: "D30EUR",
    displaySymbolZh: "DAX30指数",
    displaySymbolTw: "DAX30指數",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "IndexCFDs",
    listIndex: 2,
  },
   {
    displaySymbol: "225JPY",
    displaySymbolZh: "日经225指数",
    displaySymbolTw: "日經225指數",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "IndexCFDs",
    listIndex: 2,
  },
    {
    displaySymbol: "NVDA",
    displaySymbolZh: "英伟达",
    displaySymbolTw: "英偉達",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "StockCFDs",
    listIndex: 3,
  },
  {
    displaySymbol: "AAPL",
    displaySymbolZh: "苹果",
    displaySymbolTw: "蘋果",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "StockCFDs",
    listIndex: 3,
  },
   {
    displaySymbol: "GOOGL",
    displaySymbolZh: "谷歌 ",
    displaySymbolTw: "谷歌",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "StockCFDs",
    listIndex: 3,
  },
  {
    displaySymbol: "META",
    displaySymbolZh: "META",
    displaySymbolTw: "META",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "StockCFDs",
    listIndex: 3,
  },
  {
    displaySymbol: "TSLA",
    displaySymbolZh: "特斯拉",
    displaySymbolTw: "特斯拉",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "StockCFDs",
    listIndex: 3,
  },
 
  // {
  //   displaySymbol: "AMZN",
  //   displaySymbolZh: "亚马逊公司",
  //   displaySymbolTw: "亞馬遜公司",
  //   ask: "-",
  //   bid: "-",
  //   spread: "-",
  //   bidClassName: "",
  //   askClassName: "",
  //   type: "StockCFDs",
  //   listIndex: 3,
  // },
  // {
  //   displaySymbol: "MSFT",
  //   displaySymbolZh: "微软公司",
  //   displaySymbolTw: "微軟公司",
  //   ask: "-",
  //   bid: "-",
  //   spread: "-",
  //   bidClassName: "",
  //   askClassName: "",
  //   type: "StockCFDs",
  //   listIndex: 3,
  // },
  {
    displaySymbol: "QQQ",
    displaySymbolZh: "纳指100ETF",
    displaySymbolTw: "納指100ETF",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "ETFCFDs",
    listIndex: 4,
  },
  {
    displaySymbol: "GLD",
    displaySymbolZh: "黄金ETF",
    displaySymbolTw: "黃金ETF",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "ETFCFDs",
    listIndex: 4,
  },
  {
    displaySymbol: "ICLN",
    displaySymbolZh: "环球清洁能源ETF",
    displaySymbolTw: "環球清潔能源ETF",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "ETFCFDs",
    listIndex: 4,
  },
  {
    displaySymbol: "SMH",
    displaySymbolZh: "半导体指数ETF",
    displaySymbolTw: "半導體指數ETF",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "ETFCFDs",
    listIndex: 4,
  },
  {
    displaySymbol: "SPY",
    displaySymbolZh: "标普500ETF",
    displaySymbolTw: "標普500ETF",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "ETFCFDs",
    listIndex: 4,
  },
    {
    displaySymbol: "BTCUSD",
    displaySymbolZh: "比特币",
    displaySymbolTw: "比特幣",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "CryptoCFDs",
    listIndex: 5,
  },
   {
    displaySymbol: "noShow",
    displaySymbolZh: "noShow",
    displaySymbolTw: "noShow",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "CryptoCFDs",
    listIndex: 5,
  },
   {
    displaySymbol: "noShow",
    displaySymbolZh: "noShow",
    displaySymbolTw: "比特幣",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "CryptoCFDs",
    listIndex: 5,
  },
   {
    displaySymbol: "noShow",
    displaySymbolZh: "noShow",
    displaySymbolTw: "比特幣",
    ask: "-",
    bid: "-",
    spread: "-",
    bidClassName: "",
    askClassName: "",
    type: "CryptoCFDs",
    listIndex: 5,
  },
];
const req = require.context(
	'@/assets/image/Home/icons',
	false,
	/\.png$/
);

// 2. 转成 map：{ 文件名(无后缀) : 打包后的 url }
const iconMap = {};
req.keys().forEach(key => {
	// key 可能是 ./icon_apple.png
	const fileName = key.replace('./icon_', '').replace('.png', '');
	iconMap[fileName] = req(key);   // req(key) 就是 webpack 处理后的真实路径
});
const canvasImg = require('@/assets/image/newHome/pointEchart.png')
const earthTexture = require("@/assets/image/newHome/earth_night_4096.jpg")
const earthDisplacement = require("@/assets/image/newHome/Globe_UV Map_Displacement Map.png")
export default {
	data() {
		return {
			fadeUpObserve: '',
			section2Observe: '',
			mobileSection2DataList: '',
			mobileSection2: '',
			section3BoxObserve: '',
			Section4DataList: '',
			earthObserve: '',
			listIndex: 0,
			displaySymbolUse: '',
			wsUrl: '',
			ws: '',
			section2CanvasTimer: '',
			hasRenderEarth: false,
			section1Swiper: '',
			destroyEarth: '',
			identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
			identifyCode: "", //验证码图片内容
		}
	},
	async mounted() {
		!window.matchMedia("(max-width: 996px)").matches && this.initSection1PC()
		window.matchMedia("(max-width: 996px)").matches && this.initSection1Mobile()
		document.documentElement.setAttribute('data-fitter', 'true');

		this.displaySymbolUse = this.$i18n.locale == 'zh'
			? "displaySymbolZh"
			: this.$i18n.locale == 'ct'
				? "displaySymbolTw"
				: "displaySymbol";
		this.initInviewAnimate();
		this.pageDoOnce();
		await this.getPortfolio();
		this.initWs()
		this.identifyCode = "";
		//参数：（1）随机串内容。（2）验证码显示位数
		this.makeCode(this.identifyCodes, 4);
	},
	computed: {
        ...mapGetters([
            'signupUrl',
        ])
    },
	methods: {
		//随机数字：用于当角标拿字符串的值
		randomNum(min, max) {
			return Math.floor(Math.random() * (max - min) + min);
		},
		// 重置验证码
		refreshCode() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);
		},
		//获取验证码的值
		makeCode(o, l) {
			for (let i = 0; i < l; i++) {
				//通过循环获取字符串内随机几位
				this.identifyCode +=
					this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
			}
		},
		// 获取历史数据列表
		getListData() {
			fetch("https://www.ebccfd.com/portal/api/getSymbolAll", {
				method: "get",
			})
				.then((response) => {
					// 检查请求是否成功
					if (!response.ok) {
						throw new Error("Network response was not ok " + response.statusText);
					}
					// 将 Response 对象转换为 JSON 对象
					return response.json();
				})
				.then((response) => {
					let data = response.rows;
					this.createAllDataMeta(data);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		async getPortfolio() {
			let time = new Date().getMilliseconds()
			await this.$http('/ebc/api/getToken/run', {
				date: time,
				CheckSum: md5(time + "YISENCE")
			}).then(res => {
				this.wsUrl = "wss://pricecloud.eappservice.com/ws?token=" + res.data.data
			})
		},
		initWs() {
			this.getListData();
			this.ws = new WebSocket(this.wsUrl);
			let that = this
			this.ws.onopen = () => {
				this.ws.send("Connection succeeded");
			};
			jQuery.random = function (min, max) {
				return Math.floor(Math.random() * (max - min + 1) + min);
			};

			this.ws.onmessage = function (event) {
				try {
					var data = JSON.parse(event.data);
				} catch (e) {
					return false;
				}
				that.updateTabOneDocument({
					ask: data.tick[0].ask_price,
					bid: data.tick[0].bid_price,
					displaySymbol: data.symbol,
				});
			};

			this.ws.onerror = function (event) { };

			this.ws.onclose = function () { };
		},
		// 销毁监听
		destoryedListener() {
			this.ws.close();
			this.fadeUpObserve && this.fadeUpObserve.disconnect();
			this.section2Obsserve && this.section2Obsserve.disconnect();
			this.mobileSection2 && this.mobileSection2.disconnect();
			this.mobileSection2DataList && this.mobileSection2DataList.disconnect();
			this.section3BoxObserve && this.section3BoxObserve.disconnect();
			this.Section4DataList && this.Section4DataList.disconnect();
			this.earthObserve && this.earthObserve.disconnect();
			this.destroyEarth && this.destroyEarth()
		},
		// 进入动画
		initInviewAnimate() {
			this.fadeUpObserve = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) {
							e.target.classList.add("in-view");
							this.fadeUpObserve.unobserve(e.target);
						}
					});
				},
			);

			document
				.querySelectorAll(".scroll-fade-up, .scroll-fade-right, .scroll-fade-left")
				.forEach((el) => this.fadeUpObserve.observe(el));

			this.section2Observe = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) {
							this.drawSection2Image()
							this.numberAnimate()
							setTimeout(() => {
								section2PointPC.style.opacity = 1
							}, 500)
							this.section2Observe.unobserve(e.target);
						}
					});
				}, { threshold: 0.5 }
			);
			this.section2Observe.observe(document.querySelector(".scene2"));
			this.mobileSection2 = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) {
							this.drawSection2Image();

							this.mobileSection2.disconnect();
						}
					});
				},
				{ threshold: 0.5 }
			);
			this.mobileSection2.observe(locationEleM);

			this.mobileSection2DataList = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) {
							this.numberAnimate();
							this.mobileSection2DataList.disconnect(e.target);
						}
					});
				},
				{ threshold: 0.5 }
			);
			this.mobileSection2DataList.observe(
				document.querySelector(".section2-2 .dataList")
			);
			this.section3BoxObserve = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						if (document.querySelector(".section3 .flipped")) {
							document.querySelector(".section3 .flipped").classList.remove("flipped");
							this.unlock()
						}
					}
				});
			})
			this.section3BoxObserve.observe(document.querySelector(".section3 .cardBox"));
			this.Section4DataList = new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) {
							this.numberAnimate2();
							this.Section4DataList.disconnect();
						}
					});
				},
				{ threshold: 0.5 }
			);
			this.Section4DataList.observe(document.querySelector(".section4 .section4Bottom "));
			this.earthObserve = new IntersectionObserver((entries) => {
				entries.forEach((e) => {
					if (e.isIntersecting) {
						this.renderEarth();
						this.earthObserve.disconnect();
					}
				});
			}, {
				rootMargin: '1000px 0px 1000px 0px'   // 下边缘多 200px
			});
			this.earthObserve.observe(document.getElementById("earthShow"));

		},
		pageOverLayClick() {
			document.querySelector(".section3 .flipped")?.classList.remove("flipped");
			this.unlock();
		},
		flipBoxClick(e) {
			if (!e.target.classList.contains("rightIcon")) return;
			if (e.currentTarget.parentNode.classList.contains("flipped")) this.unlock()
			else if (!window.matchMedia("(max-width: 996px)").matches) this.lock(false)
			e.currentTarget.parentNode.classList.toggle("flipped");
		},
		numberAnimate2() {
			const cfg = {
				1: [2760, 1, "2760", ""], // 1 000
				2: [500, 0, "", ""], // 20
				3: [87.6, 1, "87.6", ""], // 98.75%
				4: [100, 0, "100", ""], // 6.0 → 0.0（倒计时）
			};
			
			
			Object.keys(cfg).forEach((key) => {
				const [end, decimals, prefix] = cfg[key];
				const $el = $(`#section4number${key}`);
				$({ countNum: 0 }).animate(
					{ countNum: end },
					{
						duration: 1000,
						easing: "linear",
						step() {
							const val =
								decimals > 0
									? (this.countNum / 10).toFixed(1)
									: Math.floor(this.countNum);
							$el.eq(0).text(val);
						},
						complete() {
							const final = decimals > 0 ? prefix : end;
							$el.eq(0).text(final);
						},
					}
				);
			});
		},
		async pageDoOnce() {
			await this.$nextTick()
			// section1
			this.section1Swiper = new Swiper(".swiper-container", {
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				loop: true,
				on: {
					slideChange: function () {
						document
							.querySelectorAll(".section1-container-bottom div")
							.forEach((item, index) => {
								// 轮播图左侧内容块
								if (index == this.realIndex) {
									document
										.querySelectorAll(".section1-container-top .container-left")
									[index].classList.add("showContainerLeft");
								} else {
									document
										.querySelectorAll(".section1-container-top .container-left")
									[index].classList.remove("showContainerLeft");
								}
								// 右侧图片
								if (window.matchMedia("(max-width: 996px)").matches) {
									$(".section1-container-top .container-right")[0].style["max-width"] = 'unset'
								}
								else {
									const containerRightWidth = [560, 528, 520, 520];
									$(".section1-container-top .container-right")[0].style["max-width"] =
										containerRightWidth[this.realIndex] + "rem";
								}

								// section1 不同背景切换
								if (this.realIndex == 0) {
									document
									.querySelector(".section1-bg2")
									.classList.add("showSection1Bg");
									document
									.querySelector(".section1-bg")
									.classList.remove("showSection1Bg");
									document
									.querySelector(".section1-bg3")
									.classList.remove("showSection1Bg");
									document.documentElement.setAttribute("data-theme", "dark");
								} else if(this.realIndex == 1 && !location.href.includes('/jp/')){
									document
									.querySelector(".section1-bg3")
									.classList.add("showSection1Bg");
									document
									.querySelector(".section1-bg")
									.classList.remove("showSection1Bg");
									document
									.querySelector(".section1-bg2")
									.classList.remove("showSection1Bg");
									document.documentElement.setAttribute("data-theme", "dark");
								} else if (this.realIndex == 2 && location.href.includes('/jp/')){
									document
									.querySelector(".section1-bg3")
									.classList.add("showSection1Bg");
									document
									.querySelector(".section1-bg")
									.classList.remove("showSection1Bg");
									document
									.querySelector(".section1-bg2")
									.classList.remove("showSection1Bg");
									document.documentElement.setAttribute("data-theme", "dark");
								} else {
									document.documentElement.setAttribute("data-theme", "light");
									document
										.querySelector(".section1-bg")
										.classList.add("showSection1Bg");
									document
										.querySelector(".section1-bg2")
										.classList.remove("showSection1Bg");
									document
									.querySelector(".section1-bg3")
									.classList.remove("showSection1Bg");
								}
								// 轮播图下方tab 显示效果
								if (index == this.realIndex) {
									item.classList.add("active");
									document
										.querySelectorAll(".section1-container-bottom-mobile div")
									[index].classList.add("active");
								} else {
									item.classList.remove("active");
									document
										.querySelectorAll(".section1-container-bottom-mobile div")
									[index].classList.remove("active");
								}
							});
					},
				},
			});




			function initSection3Top() {
				const pageHeight = window.innerHeight;
				const isMobile = window.matchMedia("(max-width: 996px)").matches;
				const section3Height = isMobile ? document.querySelector('.section2-2').offsetHeight : document.querySelector(".scene2").offsetHeight;
				if (pageHeight >= section3Height) {
					if (isMobile) {
						document.querySelector('.section2-2').style.top = `${0}px`
					}
					else {
						document.querySelector(".scene2").style.top = `${0}px`;
					}
				} else {
					if (isMobile) {
						document.querySelector('.section2-2').style.top = `${pageHeight - section3Height
							}px`
					}
					else {
						document.querySelector(".scene2").style.top = `${pageHeight - section3Height
							}px`;
					}
				}
			}
			initSection3Top();




		},
		showFormPopup() {
			console.log(123)
			document.querySelector(".formPopup").classList.add("showFormPopup");
			this.lock();
		},
		section1ContainerBottomClick(index) {
			this.section1Swiper.slideToLoop(index);
			const containerRightWidth = [560, 528, 520, 520];
			$(".section1-container-top .container-right")[0].style["max-width"] =
				containerRightWidth[index] + "rem";
		},
		lock(scrollControl = true) {
			const pageOverlay = document.getElementById("pageOverLay");
			scrollControl && document.body.classList.add("no-scroll");
			pageOverlay.style.display = "block";
			setTimeout(() => {
				pageOverlay.style.opacity = 1;
			}, 100);
		},
		unlock() {
			const pageOverlay = document.getElementById("pageOverLay");
			pageOverlay.style.opacity = 0;
			setTimeout(() => {
				pageOverlay.style.display = "none";
				document.body.classList.remove("no-scroll");
			}, 700);
		},
		initSection1PC() {
			seamscroll.init({
				dom: document.getElementsByClassName("section1-2Swiper")[0],
				direction: 2,
				step: 0.6,
				hoverStep: 0.3,
				hoverStop: false,
			});
		},
		initSection1Mobile() {
			seamscroll.init({
				dom: document.getElementsByClassName("section1-2Swiperm1")[0],
				direction: 2,
				step: 0.4,
				hoverStep: 0.2,
				hoverStop: false,
			});
			seamscroll.init({
				dom: document.getElementsByClassName("section1-2Swiperm2")[0],
				direction: 2,
				step: .3,
				hoverStep: 0.1,

				hoverStop: false,
			});
		},
		compareValues(value1, value2, className = "") {
			// 尝试将两个值转换为数字
			const num1 = Number(value1);
			const num2 = Number(value2);

			// 检查转换后的值是否都是有效的数字
			if (!isNaN(num1) && !isNaN(num2)) {
				if (num1 >= num2) {
					return "green";
				} else if (num1 < num2) {
					return "red";
				} else {
					// 两者相等的情况
					return className;
				}
			}

			// 如果转换后不是有效数字，则返回空字符串
			return "";
		},
		// 传入ask,bid,返回点差Spread
		getSpread(t, e) {
			var o = /^\+?[1-9][0-9]*$/,
				r = 0,
				d = 0,
				c = 0;
			return (
				o.test(t) || (d = t.toString().split(".")[1].length),
				o.test(e) || (c = e.toString().split(".")[1].length),
				d > c
					? 1 === d
						? (r = 10 * t - 10 * e)
						: 2 === d
							? (r = 100 * t - 100 * e)
							: 3 === d
								? (r = 1e3 * t - 1e3 * e)
								: 4 === d
									? (r = 1e4 * t - 1e4 * e)
									: 5 === d && (r = 1e5 * t - 1e5 * e)
					: 1 === c
						? (r = 10 * t - 10 * e)
						: 2 === c
							? (r = 100 * t - 100 * e)
							: 3 === c
								? (r = 1e3 * t - 1e3 * e)
								: 4 === c
									? (r = 1e4 * t - 1e4 * e)
									: 5 === c && (r = 1e5 * t - 1e5 * e),
				r.toFixed(0)
			);
		},

		// 外汇交易 Forex：EUR/USD, GBP/USD, USD/JPY, AUD/USD
		// 贵金属及能源 Commodities：XAG/USD, XAU/USD, XBR/USD, XNG/USD
		// 全球股指CFDs IndexCFDs：SPXUSD, NASUSD, U30USD, D30EUR
		// 美国股票CFDs StockCFDs：Apple, Tesla, Amazon, Microsoft

		// 创建所有数据
		createAllDataMeta(data) {
			data.map((newValue) => {
				allProducts = allProducts.map((oldValue) => {
					if (newValue.displaySymbol == oldValue.displaySymbol) {
						oldValue.askClassName = this.compareValues(newValue.ask, oldValue.ask);
						oldValue.bidClassName = this.compareValues(newValue.bid, oldValue.bid);
						oldValue.ask = this.padDecimal(
							newValue.ask,
							this.getLengthBySymbol(newValue.displaySymbol)
						);
						oldValue.bid = this.padDecimal(
							newValue.bid,
							this.getLengthBySymbol(newValue.displaySymbol)
						);
						oldValue.spread = this.getSpread(oldValue.ask, oldValue.bid);
					}
					return oldValue;
				});
			});
			this.createTabAllDocument();
		},
		getItemFormat(number, item) {
			// 定义需要特殊处理的货币对
			const specialSymbols = ["EURUSD", "GBPUSD", "USDJPY", "AUDUSD",'USDCAD'];

			// 如果不是这几种货币对，返回两个空字符串
			if (!specialSymbols.includes(item.displaySymbol)) {
				return [number, ""];
			}

			// 将 number 转为字符串
			const bidStr = number.toString();

			// 检查是否是小数
			if (bidStr.includes(".")) {
				// 拆分整数部分和小数部分
				const [integerPart, decimalPart] = bidStr.split(".");

				// 确保小数部分存在
				if (decimalPart && decimalPart.length >= 1) {
					// 不含最后一位的部分（保留小数点）
					const beforeLastDigit =
						decimalPart.length > 1
							? `${integerPart}.${decimalPart.slice(0, -1)}`
							: `${integerPart}.`; // 处理只有一位小数的情况

					// 最后一位数字
					const lastDigit = decimalPart.slice(-1);

					return [beforeLastDigit, lastDigit];
				}
			}

			// 默认情况（非小数）
			return [bidStr, ""]; // 返回原始值和空字符串
		},
		padDecimal(num, digits) {
			// 当digits为-1时，直接返回原数字
			if (digits === -1) {
				return num.toString();
			}

			// 确保digits是非负整数
			digits = Math.max(0, Math.floor(digits));

			// 将数字转换为字符串
			let numStr = num.toString();

			// 检查是否有小数点
			const decimalIndex = numStr.indexOf(".");

			if (decimalIndex === -1) {
				// 如果没有小数点，且digits>0，则添加小数点和补零
				if (digits > 0) {
					numStr += "." + "0".repeat(digits);
				}
				return numStr;
			}

			// 获取当前小数位数
			const currentDecimalDigits = numStr.length - decimalIndex - 1;

			if (currentDecimalDigits < digits) {
				// 如果当前小数位数不足，补零
				const zerosToAdd = digits - currentDecimalDigits;
				numStr += "0".repeat(zerosToAdd);
			}
			// 如果当前小数位数已经足够或更多，直接返回原数字

			return numStr;
		},
		getLengthBySymbol(symbol) {
			// 在数组中查找匹配的项
			const foundItem = listE.find((item) => item.displaySymbol === symbol);

			// 如果找到则返回length，否则返回undefined或默认值
			return foundItem ? foundItem.length : -1;
		},
		// 更新单条数据元素
		updateTabOneDocument(newValue) {
			let flag = false;
			let el = {};
			let result = allProducts.map((oldValue) => {
				if (newValue.displaySymbol == oldValue.displaySymbol) {
					flag = true;
					oldValue.askClassName = this.compareValues(
						newValue.ask,
						oldValue.ask,
						oldValue.askClassName
					);
					oldValue.bidClassName = this.compareValues(
						newValue.bid,
						oldValue.bid,
						oldValue.bidClassName
					);
					oldValue.ask = this.padDecimal(
						newValue.ask,
						this.getLengthBySymbol(newValue.displaySymbol)
					);
					oldValue.bid = this.padDecimal(
						newValue.bid,
						this.getLengthBySymbol(newValue.displaySymbol)
					);
					oldValue.spread = this.getSpread(oldValue.ask, oldValue.bid);
					el = oldValue;
				}
				return oldValue;
			});
			if (flag) {
				allProducts = result;
				let targetDoc = document.getElementById(
					el.displaySymbol +
					(window.matchMedia("(max-width: 996px)").matches ? "mobile" : "")
				);
				if (targetDoc) {
					const img = targetDoc.querySelector("[data-src]");
					const nameEl = targetDoc.querySelector("[data-name]");
					const bidEl = targetDoc.querySelector("[data-bid]");
					const askEl = targetDoc.querySelector("[data-ask]");
					const spreadEl = targetDoc.querySelector("[data-spread]");
					const newSrc = iconMap[el.displaySymbol];

					if (img.src !== newSrc) {
						img.src = newSrc;
					}
					nameEl.textContent = el[this.displaySymbolUse];

					bidEl.innerHTML =
						this.getItemFormat(el.bid, el)[0] +
						`<span>` +
						this.getItemFormat(el.bid, el)[1] +
						`</span>`;
					bidEl.classList.remove("green", "red");
					bidEl.classList.add(el.bidClassName);

					askEl.innerHTML =
						this.getItemFormat(el.ask, el)[0] +
						`<span>` +
						this.getItemFormat(el.ask, el)[1] +
						`</span>`;
					askEl.classList.remove("green", "red");
					askEl.classList.add(el.askClassName);

					// 更新 spread
					spreadEl.textContent = el.spread;
				}
			}
		},
		getRowRules(el) {
			const strategies = [
				{ predicate: (el) => el.type === "IndexCFDs", leverage: "100:1" },
				{ predicate: (el) => el.type === "StockCFDs", leverage: "5:1" },
				{ predicate: (el) => el.type === "ETFCFDs", leverage: "5:1" },
			    { predicate: (el) => el.type === "CryptoCFDs", leverage: "200:1<span style='display:inline-block;transform:translateY(-6px)'>*</span>" },
				{ predicate: (el) => el.displaySymbol === "XAGUSD", leverage: "500:1" },
				{ predicate: (el) => el.displaySymbol === "XAUUSD", leverage: "500:1" },
				{ predicate: (el) => el.displaySymbol === "XBRUSD", leverage: "100:1" },
				{ predicate: (el) => el.displaySymbol === "XNGUSD", leverage: "50:1" },
				{ predicate: (el) => el.displaySymbol === "XTIUSD", leverage: "100:1" },
				{
					predicate: (el) =>
						el.type === "Forex" &&
						!["/vi/", "/hi/", "/id/", "/th/"].some((seg) =>
							location.href.includes(seg)
						),
					leverage: "500:1",
				},
			];
			const hit = strategies.find((s) => s.predicate(el));
			let result = hit ? hit.leverage : "1000:1";
			if (location.href.includes('/th/')) {
				result = result.split(':').reverse().join(':');
			}
			return result;
		},
		createRow(el, index) {
			const targetElement = window.matchMedia("(max-width: 996px)").matches
				? document.getElementById("mobileTbody")
				: document.getElementById("pcTbody");
			const row = (targetElement.children[index] || targetElement.children[index-1]).cloneNode(true);
			row.id =
				el.displaySymbol +
				(window.matchMedia("(max-width: 996px)").matches ? "mobile" : "");
			row.querySelector("[data-bid]").classList.remove("green", "red");
			row.querySelector("[data-ask]").classList.remove("green", "red");
			row.querySelector(
				"[data-src]"
			).src = iconMap[el.displaySymbol];
			row.querySelector("[data-name]").textContent = el[this.displaySymbolUse];
			row.querySelector("[data-bid]").textContent = el.bid;
			row.querySelector("[data-ask]").textContent = el.ask;
			row.querySelector("[data-spread]").textContent = el.spread;
			row.querySelector("[data-rules]").innerHTML = this.getRowRules(el);

			return row;
		},

		render(list) {
			const targetElement = window.matchMedia("(max-width: 996px)").matches
				? document.getElementById("mobileTbody")
				: document.getElementById("pcTbody");
			const frag = document.createDocumentFragment();
			list.forEach((el, index) => frag.appendChild(this.createRow(el, index)));
			targetElement.replaceChildren(frag);
		},

		// 创建所有数据对象
		createTabAllDocument() {
			let showData = allProducts.filter((e) => {
				return this.listIndex == e.listIndex;
			});
			this.render(showData);
		},
		drawSection2Image() {
			const img = new Image();
			img.src = canvasImg;
			img.onload = run;
			function run() {
				const cvs = window.matchMedia("(max-width: 996px)").matches
					? document.getElementById("pointCanvasM")
					: document.getElementById("pointCanvas");
				const ctx = cvs.getContext("2d");
				const cw = cvs.width,
					ch = cvs.height;

				/* 1. 离屏完整清晰图 */
				const off = document.createElement("canvas");
				off.width = cw;
				off.height = ch;
				off.getContext("2d").drawImage(img, 0, 0, cw, ch);

				/* 2. 动画参数 */
				const duration = 800; // 总时长
				const stepTime = 60
				const totalStep = Math.ceil(duration / stepTime);
				const stepW = cw / totalStep; // 每步宽度
				const blurW = 20; // 右侧过渡模糊带宽

				let step = 0;
				this.section2CanvasTimer = setInterval(() => {
					const x = step * stepW; // 本次刷新的右边界
					const w = Math.min(stepW, cw - x); // 本次实际要画的宽

					ctx.clearRect(0, 0, cw, ch);

					/* 3-a 先把已出现的清晰部分一次性画出来 */
					if (x > 0) {
						ctx.drawImage(off, 0, 0, x, ch, 0, 0, x, ch);
					}

					/* 3-b 画当前清晰窄带（不含过渡） */
					const clearW = Math.max(0, w - blurW);
					if (clearW > 0) {
						ctx.drawImage(off, x, 0, clearW, ch, x, 0, clearW, ch);
					}

					/* 3-c 右侧过渡——先裁剪再模糊 */
					const blurStart = x + clearW;
					const blurRealW = Math.min(blurW, cw - blurStart);
					if (blurRealW > 0) {
						ctx.save();
						ctx.beginPath();
						ctx.rect(blurStart, 0, blurRealW, ch);
						ctx.clip(); // 只在右侧小条里画
						ctx.filter = `blur(${3}px)`; // 模糊度随宽度变化
						ctx.drawImage(
							off,
							blurStart,
							0,
							blurRealW,
							ch,
							blurStart,
							0,
							blurRealW,
							ch
						);
						ctx.filter = "none";
						ctx.restore();
					}

					step++;
					if (step >= totalStep) {
						ctx.drawImage(off, 0, 0); // 最后一帧补全
						clearInterval(this.section2CanvasTimer);
					}
				}, stepTime);
			}
		},
		initSection2Public() {
			getListData();
		},
		section2PCClick(index, innerHtml) {
			document.getElementsByClassName("index-section1-list")[0].dataset.tag = innerHtml;
			document.getElementsByClassName("index-section1-list")[0].dataset.tagIndex = index;
			if (index == this.listIndex) {
				return;
			}
			if(index == 5){
				document.getElementById('contentContainer').classList.add('tab5')
				}else {
				document.getElementById('contentContainer').classList.remove('tab5')
				}
			this.listIndex = index;
			this.createTabAllDocument();
		},
		section2MobileClick(index) {
			if (index == this.listIndex) {
				return;
			}
			 if(index == 5){
				document.getElementById('tbodyContainerM').classList.add('tab5')
			}else {
			document.getElementById('tbodyContainerM').classList.remove('tab5')
			}
			const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
			const leftPad = 16 * rem;
			const tab = document.querySelectorAll(".section2 .tab")[index];
			// 高亮
			document
				.querySelector(".section2 .tab.active")
				?.classList.remove("active");
			tab.classList.add("active");
			const wrapper = document.querySelector(".section2 .tab-wrapper");
			wrapper.scrollLeft =
				index === 0 ? tab.offsetLeft - leftPad : tab.offsetLeft;
			this.listIndex = index;
			this.createTabAllDocument();
		},
		showComfirmPopover() {
			document
				.querySelector(".section2ConfirmPopover")
				.classList.add("showConfirmPopover");
		},
		section2ConfirmPopoverClose() {
			document
				.querySelector(".section2ConfirmPopover")
				.classList.remove("showConfirmPopover");
		},


		numberAnimate() {
			const cfg = {
				5: [1000, 0, "1,000", ""], // 1 000
				6: [20, 0, "", ""], // 20
				7: [98.75, 0, "", "%"], // 98.75%
				8: [0, 1, "0.0", "s"], // 6.0 → 0.0（倒计时）
			};

			Object.keys(cfg).forEach((key) => {
				const [end, decimals, prefix] = cfg[key];
				const $el = $(
					window.matchMedia("(max-width: 996px)").matches
						? `#number${key}m`
						: `#number${key}`
				);
				$({ countNum: decimals === 1 ? 60 : 0 }).animate(
					{ countNum: end },
					{
						duration: 700,
						easing: "linear",
						step() {
							const val =
								decimals > 0
									? (this.countNum / 10).toFixed(1)
									: Math.floor(this.countNum);
							$el.eq(0).text(val);
						},
						complete() {
							const final = decimals > 0 ? prefix : end;
							$el.eq(0).text(final);
						},
					}
				);
			});
		},
		debounce(fn, delay, immediate = false) {
			let timer = null;

			return function (...args) {
				const ctx = this; // 保存 this 指向
				const callNow = immediate && !timer;

				// 每次调用都重置定时器
				clearTimeout(timer);

				timer = setTimeout(() => {
					timer = null;
					if (!immediate) fn.apply(ctx, args);
				}, delay);

				// 立即执行一次
				if (callNow) fn.apply(ctx, args);
			};
		},
		renderEarth() {
    if (this.hasRenderEarth) return;
    this.hasRenderEarth = true;

    // --- 性能优化：复用变量，避免每一帧创建新对象 ---
    const _tempV3 = new THREE.Vector3();
    const _cameraPos = new THREE.Vector3();
    const _screenPos = new THREE.Vector3();
    let activeFlyLines = []; // 存储活跃飞线

    // 防抖
    const debounce = this.debounce || ((fn, delay) => {
        let timer;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, arguments), delay);
        }
    });

    window.removeEventListener("resize", debounce(onWindowResize));
    
    // 清理容器
    const overlay = document.getElementById("overlay");
    if (overlay) overlay.innerHTML = "";
    const earthContainer = document.querySelector("#earth-container");
    if (earthContainer) earthContainer.innerHTML = "";
    
    let that = this;

    // --- 数据保持原样 ---
    const cityData = {
        阿根廷: {
            country: that.$i18n.locale == 'zh' ? "阿根廷" : that.$i18n.locale == 'ct' ? '阿根廷' : 'Argentina',
            coords: { y: -34.6037, x: -58.3816 },
            good: true,
        },
        澳大利亚: {
            country: that.$i18n.locale == 'zh' ? "澳大利亚" : that.$i18n.locale == 'ct' ? '澳大利亞' : 'Australia',
            coords: { y: -33.8688, x: 151.2093 },
            good: true,
        },
        智利: {
            country: that.$i18n.locale == 'zh' ? "智利" : that.$i18n.locale == 'ct' ? '智利' : 'Chile',
            coords: { y: -33.4489, x: -70.6693 },
        },
        哥伦比亚: {
            country: that.$i18n.locale == 'zh' ? "哥伦比亚" : that.$i18n.locale == 'ct' ? '哥倫比亞' : 'Colombia',
            coords: { y: 4.711, x: -74.0721 },
        },
        塞浦路斯: {
            country: that.$i18n.locale == 'zh' ? "塞浦路斯" : that.$i18n.locale == 'ct' ? '賽普勒斯' : 'Cyprus',
            coords: { y: 35.1856, x: 33.3823 },
            good: true,
        },
        中国香港: {
            country: that.$i18n.locale == 'zh' ? "中国香港" : that.$i18n.locale == 'ct' ? '香港（中國）' : 'Hong Kong,China',
            coords: { y: 22.3193, x: 114.1694 },
            good: true,
        },
        印度: {
            country: that.$i18n.locale == 'zh' ? "印度" : that.$i18n.locale == 'ct' ? '印度' : 'India',
            coords: { y: 28.6139, x: 77.209 },
        },
        印度尼西亞: {
            country: that.$i18n.locale == 'zh' ? "印度尼西亞" : that.$i18n.locale == 'ct' ? '印尼' : 'Indonesia',
            coords: { y: -6.2088, x: 106.8456 },
        },
        肯尼亚: {
            country: that.$i18n.locale == 'zh' ? "肯尼亚" : that.$i18n.locale == 'ct' ? '肯亞' : 'Kenya',
            coords: { y: -1.2921, x: 36.8219 },
        },
        墨西哥: {
            country: that.$i18n.locale == 'zh' ? "墨西哥" : that.$i18n.locale == 'ct' ? '墨西哥' : 'Mexico',
            coords: { y: 19.4326, x: -99.1332 },
            good: true,
        },
        尼日利亚: {
            country: that.$i18n.locale == 'zh' ? "尼日利亚" : that.$i18n.locale == 'ct' ? '奈及利亞' : 'Nigeria',
            coords: { y: 9.0579, x: 7.4951 },
        },
        巴拿马: {
            country: that.$i18n.locale == 'zh' ? "巴拿马" : that.$i18n.locale == 'ct' ? '巴拿馬' : 'Panama',
            coords: { y: 8.9824, x: -79.5199 },
        },
        秘鲁: {
            country: that.$i18n.locale == 'zh' ? "秘鲁" : that.$i18n.locale == 'ct' ? '秘魯' : 'Peru',
            coords: { y: -12.0464, x: -77.0428 },
        },
        新加坡: {
            country: that.$i18n.locale == 'zh' ? "新加坡" : that.$i18n.locale == 'ct' ? '新加坡' : 'Singapore',
            coords: { y: 1.3521, x: 103.8198 },
            good: true,
        },
        南非: {
            country: that.$i18n.locale == 'zh' ? "南非" : that.$i18n.locale == 'ct' ? '南非' : 'South Africa',
            coords: { y: -25.7479, x: 28.2293 },
        },
        英国: {
            country: that.$i18n.locale == 'zh' ? "英国" : that.$i18n.locale == 'ct' ? '英國' : 'United Kingdom',
            coords: { y: 51.5074, x: -0.1278 },
            good: true,
        },
        乌拉圭: {
            cityName: '乌拉圭',
            country: that.$i18n.locale == 'zh' ? "乌拉圭" : that.$i18n.locale == 'ct' ? '烏拉圭' : 'Uruguay',
            coords: { y: -34.9011, x: -56.1645 },
        },
        越南: {
            cityName: '越南',
            country: that.$i18n.locale == 'zh' ? "越南" : that.$i18n.locale == 'ct' ? '越南' : 'Vietnam',
            coords: { y: 21.0285, x: 105.8544 },
            good: true,
        },
        蒙古: {
            country: that.$i18n.locale == 'zh' ? "蒙古" : that.$i18n.locale == 'ct' ? '蒙古' : 'Mongolia',
            coords: { y: 47.8864, x: 106.9057 },
            good: true,
        },
        韩国: {
            country: that.$i18n.locale == 'zh' ? "韩国" : that.$i18n.locale == 'ct' ? '韓國' : 'Korea',
            coords: { y: 37.5665, x: 126.978 },
            good: true,
        },
        日本: {
            country: that.$i18n.locale == 'zh' ? "日本" : that.$i18n.locale == 'ct' ? '日本' : 'Japan',
            coords: { y: 35.6895, x: 139.6917 },
            good: true,
        },
        開曼群島: {
            country: that.$i18n.locale == 'zh' ? "開曼群島" : that.$i18n.locale == 'ct' ? '開曼群島' : 'Cayman ',
            coords: { y: 19.3133, x: -81.2546 },
            good: true,
        },
        泰国: {
            country: that.$i18n.locale == 'zh' ? "泰国" : that.$i18n.locale == 'ct' ? '泰國' : 'Thailand',
            coords: { y: 17.9757, x: 102.6331 },
        },
    };
    
    const cityList = Object.keys(cityData);
    const randomCity = () => cityList[Math.floor(Math.random() * cityList.length)];
    const OrbitControls = THREE.OrbitControls;
    
    let cityPointerInterval = [];
    let scene, camera, renderer, globe;
    let controls = "";
    // let flyLines = []; // ⚠️ 删除旧数组
    let doAnimate = true;
    let stopAll = false;
    let animationInProgress = false;
    let markerDivs = [];
    let isMobile = window.matchMedia("(max-width: 996px)").matches;
    let isSmallScreen = window.matchMedia("(max-width: 1440px)").matches;
    // ⚠️ 删除了 acternityUMD 解构，因为不再使用 Line2

    // --- 性能优化核心 1: DOM 更新 (无节流但低GC) ---
    function updateMarkerPositions() {
        // 每一帧都执行，保证拖拽跟手
        camera.getWorldPosition(_cameraPos);

        const canvasWidth = isMobile ? window.innerWidth : isSmallScreen ? 700 : 1050;
        const halfWidth = canvasWidth / 2;

        for (let i = 0, l = markerDivs.length; i < l; i++) {
            const item = markerDivs[i];
            item.marker.getWorldPosition(item.worldPos);
            
            // 手动计算点积判断背面，避免创建新对象
            _tempV3.copy(item.worldPos).normalize();
            const toCameraX = _cameraPos.x - item.worldPos.x;
            const toCameraY = _cameraPos.y - item.worldPos.y;
            const toCameraZ = _cameraPos.z - item.worldPos.z;
            const dot = _tempV3.x * toCameraX + _tempV3.y * toCameraY + _tempV3.z * toCameraZ;
            
            if (dot <= 0) {
                if (item.div.style.display !== "none") item.div.style.display = "none";
                continue;
            }

            _screenPos.copy(item.worldPos);
            _screenPos.project(camera);

            if (_screenPos.z > -1 && _screenPos.z < 1) {
                if (item.div.style.display !== "block") item.div.style.display = "block";

                const x = (_screenPos.x * halfWidth) + halfWidth;
                const y = (-_screenPos.y * halfWidth) + halfWidth;
                let transformXValue = 0;

                if (["马来西亚", "乌拉圭", "越南"].includes(item.city.cityName)) {
                    transformXValue = isMobile ? x - 70 : x - 123;
                } else {
                    transformXValue = isMobile ? x + 5 : x - 5;
                }
                const transformYValue = y - 10;
                
                // 使用 toFixed 稳定数值
                item.div.style.transform = `translate3d(${transformXValue.toFixed(2)}px, ${transformYValue.toFixed(2)}px, 0)`;

                if (_screenPos.y > -0.3 && _screenPos.y < 0.3 && _screenPos.x > -0.3 && _screenPos.x < 0.3 && item.good) {
                    if (!item.div.classList.contains("inCenter")) item.div.classList.add("inCenter");
                } else {
                    if (item.div.classList.contains("inCenter")) item.div.classList.remove("inCenter");
                }
            } else {
                if (item.div.style.display !== "none") item.div.style.display = "none";
            }
        }
    }

    // --- 性能优化核心 2: 飞线 (Native Line + BufferGeometry) ---
    function createFlyLine(fromCity, toCity) {
        if (stopAll) return;
        const from = cityData[fromCity].coords;
        const to = cityData[toCity].coords;
        
        // ⚠️ 保持原代码参数：radius 1.16, segments 100
        const pointsVectors = calculateGreatCirclePoints(from.y, from.x, to.y, to.x, 1.16, 100);
        
        // 使用 BufferGeometry 替代 FatLine
        const geometry = new THREE.BufferGeometry().setFromPoints(pointsVectors);
        geometry.setDrawRange(0, 0); // 初始隐藏

        // 使用 LineBasicMaterial 替代 LineMaterial
        const material = new THREE.LineBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.8, // 保持原代码 opacity
        });

        const line = new THREE.Line(geometry, material);
        globe.add(line);

        // 推入数组在 animate 中循环，替代 setTimeout
        activeFlyLines.push({
            mesh: line,
            totalPoints: pointsVectors.length,
            currentCount: 0,
            phase: 'grow',
            speed: 1.5, // 模拟原代码 growth 速度
            toCity: toCity
        });
    }

    // --- 保持原逻辑 ---
    function calculateGreatCirclePoints(lat1, lon1, lat2, lon2, radius, segments) {
        const points = [];
        const phi1 = THREE.MathUtils.degToRad(lat1);
        const theta1 = THREE.MathUtils.degToRad(lon1);
        const phi2 = THREE.MathUtils.degToRad(lat2);
        const theta2 = THREE.MathUtils.degToRad(lon2);
        
        const startVector = new THREE.Vector3(
            Math.cos(phi1) * Math.cos(theta1),
            Math.sin(phi1),
            -Math.cos(phi1) * Math.sin(theta1)
        ).multiplyScalar(radius);
        
        const endVector = new THREE.Vector3(
            Math.cos(phi2) * Math.cos(theta2),
            Math.sin(phi2),
            -Math.cos(phi2) * Math.sin(theta2)
        ).multiplyScalar(radius);
        
        const normal = new THREE.Vector3().crossVectors(startVector, endVector).normalize();
        const angle = startVector.angleTo(endVector);
        
        for (let i = 0; i <= segments; i++) {
            const t = i / segments;
            const currentAngle = t * angle;
            const rotationMatrix = new THREE.Matrix4().makeRotationAxis(normal, currentAngle);
            const point = startVector.clone().applyMatrix4(rotationMatrix);
            
            // ⚠️ 严格保持原代码高度：0.15
            const elevation = 0.15 * Math.sin(Math.PI * t); 
            const elevatedPoint = point.clone().multiplyScalar(1 + elevation);
            points.push(elevatedPoint);
        }
        return points;
    }

    // --- 保持原逻辑 ---
    function createCityMarker(cityName) {
        const city = cityData[cityName];
        const countryName = city.country;
        const teamWord = that.$i18n.locale == 'zh' ? '团队' : that.$i18n.locale == 'ct' ? '團隊' : 'Team'
        const seeWord = that.$i18n.locale == 'zh' ? '与我们见面' : that.$i18n.locale == 'ct' ? '與我們見面' : 'Contact Us'
        
        // ⚠️ 保持原代码参数：radius 1.16
        const position = latLongToVector3(city.coords.y, city.coords.x, 1.16);
        const geometry = new THREE.CircleGeometry(0.015, 32); 
        const material = new THREE.MeshBasicMaterial({
            color: "#fff",
            side: THREE.DoubleSide,
        });
        const marker = new THREE.Mesh(geometry, material);
        marker.position.copy(position);
        
        const normal = position.clone().normalize();
        marker.lookAt(normal);
        marker.userData = { ...city, type: "dot" };
        globe.add(marker);

        const overlay = document.getElementById("overlay");
        if (!overlay) return;
        
        const markerDiv = document.createElement("div");
        markerDiv.innerHTML = `<div class="flex"> 
<div class="transparentDot"></div>
<div class="wordPart">
<div class="text1 pc">${seeWord}<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M13.8388 6.25L6.76777 6.25M13.8388 6.25L13.8388 13.3211M13.8388 6.25L5 15.0888" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div> 
<div class="text2 md-footnote-regular_12">${countryName} ${teamWord}</div>
</div></div>`;
        markerDiv.className = "marker-dot";
        if (cityName == "乌拉圭" || cityName == "马来西亚" || cityName == "越南") {
            markerDiv.className = "marker-dot marker-dot-left";
        }
        markerDiv.dataset.city = city;
        markerDivs.push({
            div: markerDiv,
            marker: marker,
            city: city,
            good: city.good || false,
            worldPos: new THREE.Vector3(),
        });
        overlay.appendChild(markerDiv);

        markerDiv.addEventListener("click", (e) => {
            const isMobileNow = window.matchMedia("(max-width: 996px)").matches;
            if (isMobileNow) return;
            if (animationInProgress || !doAnimate) return;
            
            setTimeout(() => { that.showFormPopup(); }, 500);
            
            animationInProgress = true;
            controls.enabled = false;
            
            const targetPosition = new THREE.Vector3();
            targetPosition.setFromMatrixPosition(marker.matrixWorld);
            const targetDirection = targetPosition.clone().normalize();
            const currentDistance = camera.position.length();
            const newPosition = targetDirection.clone().multiplyScalar(currentDistance);
            
            new TWEEN.Tween(camera.position)
                .to(newPosition, 1000)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() => {
                    camera.lookAt(targetPosition);
                    controls.update();
                })
                .onComplete(() => {
                    animationInProgress = false;
                    controls.enabled = true;
                    doAnimate = false;
                })
                .start();
        });

        function createRipple() {
            // 优化分段数
            const rippleGeometry1 = new THREE.RingGeometry(0.01, 0.011, 32);
            const rippleGeometry2 = new THREE.RingGeometry(0.015, 0.016, 32);
            const rippleMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                transparent: true,
                opacity: 1,
                side: THREE.DoubleSide,
            });

            const ripple1 = new THREE.Mesh(rippleGeometry1, rippleMaterial);
            const ripple2 = new THREE.Mesh(rippleGeometry2, rippleMaterial);

            ripple1.position.copy(marker.position);
            ripple2.position.copy(marker.position);

            const normal = marker.position.clone().normalize();
            const elevation = 0.001;
            ripple1.position.add(normal.clone().multiplyScalar(elevation));
            ripple2.position.add(normal.clone().multiplyScalar(elevation));

            ripple1.lookAt(normal.add(ripple1.position));
            ripple2.lookAt(normal.add(ripple2.position));

            globe.add(ripple1);
            globe.add(ripple2);

            const targetScale = 3;
            const duration = 1500;
            
            new TWEEN.Tween({ scale: 1.1, opacity: 0.9 })
                .to({ scale: targetScale, opacity: 0.2 }, duration)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((obj) => {
                    ripple1.scale.set(obj.scale, obj.scale, 0);
                    ripple1.material.opacity = obj.opacity;
                })
                .onComplete(() => { globe.remove(ripple1); })
                .start();

            new TWEEN.Tween({ scale: 1.1, opacity: 0.9 })
                .to({ scale: targetScale, opacity: 0.2 }, duration - 100)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((obj) => {
                    ripple2.scale.set(obj.scale, obj.scale, 0);
                    ripple2.material.opacity = obj.opacity;
                })
                .onComplete(() => { globe.remove(ripple2); })
                .start();
        }
        createRipple();
        let intervalTimer = setInterval(createRipple, 3000);
        cityPointerInterval.push(intervalTimer);
    }

    function latLongToVector3(lat, lon, radius) {
        const phi = ((90 - lat) * Math.PI) / 180;
        const theta = ((lon + 180) * Math.PI) / 180;
        return new THREE.Vector3(
            -radius * Math.sin(phi) * Math.cos(theta),
            radius * Math.cos(phi),
            radius * Math.sin(phi) * Math.sin(theta)
        );
    }

    function initCamera() {
        setTimeout(() => {
            const startPosition = latLongToVector3(51.5074, -0.1278, isMobile ? 3.3 : 3.5);
            camera.position.copy(startPosition);
            camera.lookAt(startPosition);
            controls.update();
        });
    }

    function init() {
        scene = new THREE.Scene();
        scene.fog = new THREE.Fog(0x000022, 5, 15);
        
        camera = new THREE.PerspectiveCamera(45, 1, 0.1, 1000);
        camera.position.z = isMobile ? 2.7 : 4.3;
        
        // --- 性能优化配置 ---
        renderer = new THREE.WebGLRenderer({
            antialias: window.devicePixelRatio < 2, // 优化：高清屏关闭AA
            alpha: true,
            // ⚠️ 移除 logarithmicDepthBuffer，提升性能
        });

        if (isMobile) {
            renderer.setSize(window.innerWidth, window.innerWidth);
        } else {
            const result = window.matchMedia("(max-width: 1440px)").matches ? 700 : 1050;
            renderer.setSize(result, result);
        }
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2)); // 限制DPR
        
        document.getElementById("earth-container").appendChild(renderer.domElement);

        controls = new OrbitControls(camera, renderer.domElement);
        controls.enableZoom = false;
        controls.enablePan = false;
        controls.enableDamping = true;
        controls.dampingFactor = .05;
        controls.minDistance = 1;
        controls.maxDistance = 10;

        createEarth();
        
        const ambientLight = new THREE.AmbientLight(0xffffff, 1.2);
        scene.add(ambientLight);

        const light = new THREE.SpotLight(0xffffff, 1, 0, Math.PI / 2);
        camera.add(light); 
        light.position.set(-20, 10, 0); 
        scene.add(camera);
        
        initCamera();

        Object.keys(cityData).forEach((city) => createCityMarker(city));
        
        // 原有逻辑：分批创建
        setTimeout(() => { createFlyLine("中国香港", "阿根廷"); }, 500);
        setTimeout(() => { createFlyLine("印度尼西亞", "乌拉圭"); }, 1000);
        setTimeout(() => { createFlyLine("印度尼西亞", "乌拉圭"); }, 1500);
        setTimeout(() => { createFlyLine("智利", "巴拿马"); }, 2000);
        setTimeout(() => { createFlyLine("韩国", "哥伦比亚"); }, 2500);
        setTimeout(() => { createFlyLine("墨西哥", "秘鲁"); }, 200);
        setTimeout(() => { createFlyLine("英国", "蒙古"); }, 1200);
        setTimeout(() => { createFlyLine("澳大利亚", "智利"); }, 2200);
        createFlyLine("塞浦路斯", "肯尼亚");

        window.addEventListener("resize", debounce(onWindowResize, 500));
        
        animate(false);
        dealFormPopup();
    }

    function dealFormPopup() {
        const closeBtn = document.querySelector(".formPopupClose");
        if(closeBtn) {
            closeBtn.addEventListener("click", function () {
                document.querySelector(".formPopup").classList.remove("showFormPopup");
                that.unlock(); 
                doAnimate = true;
                animate();
            });
        }
        // ... 请保留你原有的完整表单逻辑，包括 msg_alert 等函数 ...
        function msg_alert(msg) {
             $("html").append(
                '<div id="contact-alert" style="font-family: siyuan;  padding: 6px 20px; color: rgb(255, 255, 255); text-align: center; border-radius: 4px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999999999999; background: rgba(0, 0, 0, 0.7); font-size: 16px; transition: -webkit-transform 0.5s ease-in 0s, opacity 0.5s ease-in 0s;">' +
                    msg +
                    "</div>"
            );
            setTimeout(function () {
                $("#contact-alert").remove();
            }, 2500);
        }

        $("#form-submit").click(function (e) {
            e.preventDefault();
            var name = $("#formName").val();
            var phone_email = $("#formEmail").val();
            var phone = $("#formTel").val();
            var lang = "";
            var verify = $("#formVerify").val();
            var msg_name = "";
            var msg_phone_email = "";
            var msg_verify = "";

             if (that.$i18n.locale == 'zh') {
                lang = "cn";
                msg_name = "请输入您的称呼!";
                msg_phone_email = "请输入您的邮箱!";
                msg_verify = "请输入验证码!";
            } else if (that.$i18n.locale == 'ja') {
                lang = "jp";
                msg_name = "タイトルを入力してください！";
                msg_phone_email = "あなたのメールアドレスを入力してください！";
                msg_verify = "確認コードを入力してください!";
            } else if (that.$i18n.locale == 'ko') {
                lang = "kr";
                msg_name = "제목을 입력해주세요!";
                msg_phone_email = "이메일을 입력해주세요!";
                msg_verify = "인증번호를 입력해주세요!";
            } else if (that.$i18n.locale == 'th') {
                lang = "th";
                msg_name = "กรุณากรอกชื่อของคุณ";
                msg_phone_email = "กรุณากรอกอีเมล์ของคุณ!";
                msg_verify = "กรุณากรอกรหัสยืนยัน!";
            } else if (that.$i18n.locale == 'vn') {
                lang = "vi";
                msg_name = "Vui lòng nhập tên của bạn";
                msg_phone_email = "Vui lòng nhập email của bạn!";
                msg_verify = "Vui lòng nhập mã xác nhận!";
            } else if (that.$i18n.locale == 'ct') {
                lang = "zh";
                msg_name = "請輸入您的稱呼!";
                msg_phone_email = "請輸入您的信箱!";
                msg_verify = "請輸入驗證碼!";
            } else {
                lang = "en";
                msg_name = "Please enter your name!";
                msg_phone_email = "Please enter your email!";
                msg_verify = "Please enter verification code!";
            }

            if (name == "") {
                msg_alert(msg_name);
                return false;
            }
            if (phone_email == "") {
                msg_alert(msg_phone_email);
                return false;
            }
            if (verify == "") {
                msg_alert(msg_verify);
                return false;
            }

            $.ajax({
                type: "POST",
                url: "https://ebccfd.com/contact-us/formSubmit/",
                dataType: "json",
                data: {
                    name: name,
                    phone_email: phone_email,
                    verify: verify,
                    lang: lang,
                    phone: phone,
                },
                async: false,
                error: function (request) {
                    msg_alert("提交失败，请联系客服");
                },
                success: function (da) {
                    if (da.code == 1) {
                        msg_alert(da.msg);
                        $(".verify_img").click();
                        $("#formName").val("");
                        $("#formEmail").val("");
                        $("#formTel").val("");
                        $("#formVerify").val("");
                        $(".formPopupClose")[0].click();
                    } else {
                        msg_alert(da.msg);
                    }
                },
            });
        });
    }

    // --- 保持原逻辑 ---
    function createEarth() {
        const geometry = new THREE.SphereGeometry(1.16, 128, 128); // 保持高分段
        const textureLoader = new THREE.TextureLoader();
        // 使用原有的贴图逻辑
        const texture = textureLoader.load(earthTexture || "/ebc-static/image/newHome/earth_night_4096.jpg");
        texture.anisotropy = Math.min(renderer.capabilities.getMaxAnisotropy(), 4);
        
        const displacementMap = textureLoader.load(earthDisplacement || "/ebc-static/image/newHome/Globe_UV Map_Displacement Map.png?v=11221");

        const material = new THREE.MeshStandardMaterial({
            map: texture,
            // displacementMap: displacementMap,
            // displacementScale: 0.3, // 保持原参数
        });

        globe = new THREE.Mesh(geometry, material);
        scene.add(globe);

        // 大气层 Shader 保持不变
        const atmosphereVertexShader = `varying vec3 vNormal;void main(){vNormal=normalize(normalMatrix*normal);gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}`;
        const atmosphereFragmentShader = `uniform vec3 glowColor;uniform float power;uniform float intensity;varying vec3 vNormal;void main(){float fresnel=pow(intensity-dot(vNormal,vec3(0.0,0.0,1.0)),power);gl_FragColor=vec4(glowColor,fresnel);}`;
        const atmosphereUniforms = {
            glowColor: { value: new THREE.Color("gray") },
            power: { value: 1.8 },
            intensity: { value: 0.25 },
        };
        const atmosphereMat = new THREE.ShaderMaterial({
            uniforms: atmosphereUniforms,
            vertexShader: atmosphereVertexShader,
            fragmentShader: atmosphereFragmentShader,
            side: THREE.BackSide,
            blending: THREE.AdditiveBlending,
        });
        const atmosphereGeo = new THREE.SphereGeometry(1.26, 64, 64);
        const atmosphere = new THREE.Mesh(atmosphereGeo, atmosphereMat);
        scene.add(atmosphere);
    }

    let isUserInteracting = false;
    function onPointerDown() { isUserInteracting = true; }
    function onPointerUp() { setTimeout(() => { isUserInteracting = false; }, 1000); }
    document.addEventListener("touchstart", onPointerDown);
    document.addEventListener("touchend", onPointerUp);

    function onWindowResize() {
        if (isUserInteracting) return;
        isMobile = window.matchMedia("(max-width: 996px)").matches;
        isSmallScreen = window.matchMedia("(max-width: 1440px)").matches;
        const canvasWidth = isMobile ? window.innerWidth : isSmallScreen ? 700 : 1050;

        camera.position.x = 0;
        camera.aspect = 1;
        initCamera();
        camera.updateProjectionMatrix();
        renderer.setSize(canvasWidth, canvasWidth);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }

    const canvasObserve = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                doAnimate = true;
                animate();
            } else {
                doAnimate = false;
            }
        });
    }, { root: null, rootMargin: "0px", threshold: 0.4 });

    const earthCanvas = document.getElementById("earth-container");
    if (earthCanvas) canvasObserve.observe(earthCanvas);

    let startTime = performance.now();

    function animate() {
        if (!doAnimate) return;
        requestAnimationFrame(animate);
        
        if (performance.now() - startTime < 16) return;
        startTime = performance.now();

        controls.update();
        TWEEN.update();
        
        if (globe && !animationInProgress) {
            globe.rotation.y += 0.0005;
        }

        // --- 性能优化核心 3: 在主循环中驱动动画 (零GC) ---
        for (let i = activeFlyLines.length - 1; i >= 0; i--) {
            const flyObj = activeFlyLines[i];
            const line = flyObj.mesh;
            
            if (flyObj.phase === 'grow') {
                flyObj.currentCount += flyObj.speed;
                // 利用 BufferGeometry 的绘制范围特性
                line.geometry.setDrawRange(0, Math.floor(flyObj.currentCount));
                if (flyObj.currentCount >= flyObj.totalPoints) {
                    flyObj.currentCount = flyObj.totalPoints;
                    flyObj.phase = 'shrink';
                }
            } else if (flyObj.phase === 'shrink') {
                flyObj.currentCount -= flyObj.speed;
                const start = flyObj.totalPoints - Math.floor(flyObj.currentCount);
                line.geometry.setDrawRange(start, Math.floor(flyObj.currentCount));

                if (flyObj.currentCount <= 0) {
                    // 销毁并重生
                    globe.remove(line);
                    line.geometry.dispose();
                    line.material.dispose();
                    activeFlyLines.splice(i, 1);
                    createFlyLine(flyObj.toCity, randomCity());
                }
            }
        }

        updateMarkerPositions(); 
        renderer.render(scene, camera);
    }

    init();

    this.destroyEarth = function () {
        console.log('Destroying Earth visualization...');
        stopAll = true;
        doAnimate = false;

        if (typeof TWEEN !== 'undefined' && TWEEN.removeAll) TWEEN.removeAll();

        cityPointerInterval.forEach(id => clearInterval(id));
        cityPointerInterval = [];

        window.removeEventListener("resize", debounce(onWindowResize));
        document.removeEventListener("touchstart", onPointerDown);
        document.removeEventListener("touchend", onPointerUp);

        markerDivs.forEach(item => {
            if (item.div && item.div.parentNode) item.div.parentNode.removeChild(item.div);
        });
        markerDivs = [];

        const overlayEl = document.getElementById("overlay");
        if (overlayEl) overlayEl.innerHTML = "";

        // 清理飞线
        activeFlyLines.forEach(item => {
            if (globe) globe.remove(item.mesh);
            if (item.mesh.geometry) item.mesh.geometry.dispose();
            if (item.mesh.material) item.mesh.material.dispose();
        });
        activeFlyLines = [];

        if (scene) {
            scene.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach(m => disposeMaterial(m));
                        } else {
                            disposeMaterial(child.material);
                        }
                    }
                }
            });
            scene.clear();
            scene = null;
        }

        function disposeMaterial(material) {
            if (!material) return;
            Object.keys(material).forEach(key => {
                if (material[key] && typeof material[key].dispose === 'function') {
                    material[key].dispose();
                }
            });
            material.dispose();
        }

        if (controls && controls.dispose) {
            controls.dispose();
            controls = null;
        }

        if (renderer) {
            renderer.dispose();
            renderer.forceContextLoss();
            if (renderer.domElement && renderer.domElement.parentNode) {
                renderer.domElement.parentNode.removeChild(renderer.domElement);
            }
            renderer = null;
        }

        globe = null;
        camera = null;
        animationInProgress = false;
    };
}

	},
	destroyed() {
		console.log(123)
		this.destoryedListener()
		document.documentElement.removeAttribute('data-fitter');
	}
}
</script>
<style>
.section1-container-top .whiteTitle h2 span {
	color: var(--ebc-text-primary_white);
}

.section4 .marker-dot-left .transparentDot {
	order: 2;
}

.section1-container-top .container-left .starLogo {
	font-size: 20rem;
	display: inline-block;
	transform: translateY(-30rem);
	font-weight: 400;
	opacity: .6;
	padding-right: 10rem;
	height: 20px;
}

.section4 .marker-dot {
	position: absolute;
	background-color: transparent;
	cursor: pointer;
	pointer-events: auto;
	/* transform: translate(-50%, -50%); */
	width: fit-content;
	height: auto;
	text-align: left;
	line-height: 15px;
	z-index: 100;
}

.section4 .marker-dot .wordPart {
	padding: 2px 5px 5px;
	transform: scale(0);
	transition: transform .2s linear;
	backdrop-filter: blur(2px);
	-webkit-backdrop-filter: blur(2px);
	background: rgba(88, 87, 87, 0.2);
	border-radius: var(--ebc-corner-radius-rc12);
}

.section4 .marker-dot .transparentDot {
	background-color: transparent;
	width: 20rem;
	height: 20rem;
}

.section4 .marker-dot:hover .wordPart {
	transform: scale(1);

}

.section4 .inCenter .wordPart {
	transform: scale(1);
}

.section4 .marker-dot .text1 {
	color: var(--ebc-text-primary_white);
	font-size: 18px;
	font-weight: 500;
}

.section4 .marker-dot .text2 {
	color: var(--ebc-basecolor-white-85);
	font-size: 16px;
	font-weight: 400;
	margin-top: 9px;
}

@media screen and (max-width: 996px) {
	.section4 .marker-dot .wordPart {
		display: block;
		background: none;
		padding: 0;
		border-radius: 0;
		backdrop-filter: none;
		-webkit-backdrop-filter: none;
	}



	.section4 .marker-dot .wordPart div:nth-child(2) {
		font-size: 20rem;
	}

	.section4 .marker-dot .transparentDot {
		display: none;
	}
}
</style>
<style lang="scss" scoped>
.navigate-logo {
	box-sizing: border-box;
}

body {
	overflow-x: hidden;
}

a {
	text-decoration: none;
}

body.no-scroll {
	overflow: hidden;
}



.section2-scroll-fade-up {
	transform: translateY(-50rem);
	opacity: 0;
	transition: transform .8s cubic-bezier(0.56, 0.22, 0.42, 0.94), opacity .8s cubic-bezier(0.56, 0.22, 0.42, 0.94) !important;
}

.in-view2 {
	transform: translateY(-130rem);
	opacity: 1;
}




@media (max-height: 850px) and (min-width: 996px) {
	.section1 {
		height: 900rem !important;
	}

	.section1-bg,
	.section1-bg2 {
		height: 800rem !important;
	}

	.section1-bg .topBg {
		height: 100% !important
	}

	.section1 .section1-container-top {
		padding: 220rem 0 50rem !important
	}

	.ug .section1 .section1-container-top,
	.vi .section1 .section1-container-top {
		align-items: flex-start !important;
	}

	.sticky-box {
		top: 0rem !important;
	}

	#scene h2 {
		margin-bottom: 10rem !important;
	}

	#scene h3 {
		margin: 5rem 0 30rem !important;
	}

	.section1-container-bottom {
		transform: translateX(-50%) scale(0.7) !important;
	}

	.section1-2 {
		margin-top: -45rem;
	}

	.section1-container-top .container-left .btn,
	.section1-container-top .container-left .btn1 {
		margin-top: 70rem !important;
	}

	.section1-container-top .container-left:nth-child(3) .btn {
		margin-top: 40rem !important;
	}
}

@media (max-height: 850px) and (min-width: 996px) and (max-width: 1200px) {
	.section1 {
		height: 830rem !important;
	}

	.section1-bg,
	.section1-bg2 {
		height: 730rem !important;
	}

	.section1-bg .topBg {
		height: 100% !important
	}

	.section1 .section1-container-top {}

	.section1-container-top .container-left:nth-child(3) .btn {
		margin-top: 40rem !important;
	}
}

#pageOverLay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, .8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	display: none;
	opacity: 0;
	transition: opacity .6s ease;
}

.section1 {
	height: 1100rem;
	position: relative;
	margin-top: -44rem;
}

.showSection1Bg {
	display: block !important;
}

.section1-bg {
	display: none;
	position: absolute;
	z-index: 0;
	inset: 0;
	height: 100%;

}

.section1-bg .topBg {
	width: 100%;
	height: 980rem;
	background: url("../assets/image/newHome/section1Bgw.jpg") no-repeat;
	background-size: cover;
	background-position: center;
}

.section1-bg .bottomBg {
	width: 100%;
	height: calc(100% - 980rem);
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
	transform: translateY(-100%);
}

.section1-bg2 {
	display: none;
	position: absolute;
	z-index: 0;
	inset: 0;
	height: 980rem;
	overflow: hidden;
	background: url("../assets/image/newHome/section1Bgb.jpg") no-repeat;
	background-size: cover;
	background-position: center;
	/* filter: blur(20px); */
}
.section1-bg3 {
  display: none;
  position: absolute;
  z-index: 0;
  inset: 0;
  height: 980rem;
  overflow: hidden;
  background: url("../assets/image/newHome/section1Bgblue.jpg") no-repeat;
  background-size: cover;
  background-position: center;
}
.section1-bg2::before {
	content: '';
	position: absolute;
	top: -10px;
	left: -50px;
	right: -20px;
	bottom: -5px;
	filter: blur(20px);
	background: url("../assets/image/newHome/section1Bgb.jpg");
	background-size: cover;
	background-position: center;
	z-index: -1;
}

.section1BgForBottom {
	position: absolute;
	z-index: -2;
	inset: 0;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
	background-size: 100% 100%;
}

.vi .section1 .section1-container-top {
	padding: 150rem 0 150rem;
}

.section1 .section1-container-top {
	padding: 300rem 0 100rem;
	margin: 0 auto;
	max-width: 1200rem;
	height: 100%;
	box-sizing: border-box;
}

.th .section1 .section1-container-top,
.ug .section1 .section1-container-top,
.mn .section1 .section1-container-top {
	padding: 200rem 0;

}

.section1-container-top .container-left {
	max-width: 660rem;
	position: relative;
	z-index: 1;
}

.section1-container-top .container-left .super_large-80_bold {
	color: var(--ebc-text-primary);
}


 .section1-container-top .container-left .super_large-80_bold,
 .section1-container-top .container-left h1 {
  font-size: 72rem;
  line-height: 80rem;
  margin:0;
}
 .section1-container-top .container-left .super_large-80_bold,
 .section1-container-top .container-left h1 {
  font-size: 72rem;
  line-height: 80rem;
  margin:0;
}
.en .section1-container-top .container-left .super_large-80_bold,
.en .section1-container-top .container-left h1 {
	font-size: 64rem;
	line-height: 68rem;
	margin: 0;
}
.en .section1-container-top .container-left .super_large-80_bold,
.en .section1-container-top .container-left h1{
	font-size: 56rem;
	line-height: 64rem;
}
.jp .container-left:first-child .super_large-80_bold{
	white-space: nowrap;
}
@media screen and (min-width: 996px) and (max-width: 1440px) {
	.en .section1-container-top .container-left h1 {
		font-size: 56rem;
		line-height: 64rem;
	}

	.ug .section1-container-top .container-left h1,
	.mn .section1-container-top .container-left h1 {
		font-size: 48rem;
		line-height: 54rem;
	}

	.mn .section1-container-top {
		align-items: flex-start !important;
	}

	.en .section1 .section1-container-top {
		max-width: 1200rem;
	}
}

.section1-container-top .container-left h2 {
	color: var(--ebc-text-secondary);
	margin: 24rem 0 48rem;
}
.section1-container-top .container-left h3{
  margin-top: -35rem;
  color: #fff;
}
.section1-container-top .container-left h2 span {
	color: var(--ebc-text-primary);
}

.section1-container-top .whiteTitle h1 {
	color: var(--ebc-text-primary_white) !important;
}
.section1-container-top .yellowTitle .super_large-80_bold{
  color: #FCC400 !important;
}
.section1-container-top .yellowTitle h3{
	display: none;
}
.section1-container-top .yellowTitle h2,
.section1-container-top .whiteTitle h2 {
	color: var(--ebc-text-secondary_white);
}

.section1-container-top .container-left.yellowTitle .btn {
  background: #FCC400;
  color: var(--ebc-text-primary);
}
.section1-container-top .container-left.yellowTitle .btn img{
    filter: invert(1) brightness(0);
}

.section1-container-top .container-left .dataList {
	gap: 56rem;
}

.section1-container-top .container-left .dataList .data {
	color: var(--ebc-text-primary_white);
	text-align: center;
}

.section1-container-top .container-left .dataList .desc {
	color: var(--ebc-text-secondary_white);
	// margin-top: 8rem;
}

.section1-container-top .container-left .tagList {
	display: flex;
	flex-wrap: wrap;
	gap: 16rem;
	row-gap: 5rem;
	color: var(--ebc-text-primary);
	margin-top: 40rem;
}

.section1-container-top .container-left .tagList div {
	padding: 8rem 20rem;
	border-radius: 8rem;
	background: rgba(255, 255, 255, 0.3);
	backdrop-filter: blur(4rem);
	-webkit-backdrop-filter: blur(4rem);
	font-size: 16rem;
}

.ar .section1-container-top .container-left .btn {
	margin-left: 24rem;
}

.section1-container-top .container-left .btn {
	background-color: var(--ebc-functional-active-normal);
	color: var(--ebc-basecolor-white-100);
	padding: 0 24rem;
	width: fit-content;
	height: 48rem;
	margin-top: 96rem;
	border-radius: var(--ebc-corner-radius-full);
	cursor: pointer;
	box-sizing: border-box;
	gap: 8rem;
}

.animateBtn img:first-child {
	width: 0rem;
}

.animateBtn:hover img:first-child {
	width: 20rem;
}

.animateBtn:hover img:nth-of-type(2) {
	width: 0rem;
}

.animateBtn img {
	width: 20rem;
	height: 20rem;
	transition: all 0.5s ease;
}

.section1-container-top .container-left .btn1 {
	margin: 96rem 0 0 24rem;
	color: var(--ebc-text-primary_white);
	border-radius: var(--ebc-corner-radius-full);
	border: 1rem solid #fff;
	min-width: 160rem;
	padding: 0 24rem;
	box-sizing: border-box;
	height: 48rem;
	cursor: pointer;
}

.section1-container-top .container-left .btn1:hover {
	background: var(--ebc-basecolor-white-12)
}

.section1-container-top {
	overflow: hidden;
}

.showContainerLeft {
	display: block !important;
}

.section1-container-top .container-left {
	display: none;
}

.section1-container-top .container-right {
	max-width: 620rem;
	/* overflow: hidden; */
}

.section1-swiper {
	pointer-events: none;
	overflow: visible;
}

.section1-swiper .swiper-slide {
	width: 1%;
	height: 1%;
	transform: scale(0.01) !important;
	opacity: 0;
	transform-origin: 50% 50%;
	//   text-align: center;
}

.section1-swiper .swiper-slide-active {
	width: 100%;
	height: 100%;
	transform: scale(1) !important;
	transition: transform 0.8s, opacity 0.2s;
	opacity: 1;
}

.section1-swiper .swiper-slide img {
	height: auto;
}

.section1-swiper .slide-1 img {
	width: 560rem;
	margin-top: -20rem;
}

.section1-swiper .slide-2 img {
	width: 520rem;
	margin-top: -30rem;
}

.section1-swiper .slide-3 img {
	width: 520rem;
	margin-top: -30rem;
}

.section1-swiper .slide-4 img {
	width: 560rem;
	margin-top: 0rem;
}

.section1-container-bottom-mobile {
	display: none;
}

.section1-container-bottom {
	gap: 16rem;
	height: 160rem;
	position: absolute;
	bottom: 25rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 2;
}

.section1-container-bottom div {
	width: 150rem;
	height: 120rem;
	border-radius: var(--ebc-corner-radius-rc12);
	border: 0.75rem solid rgba(255, 255, 255, 0.6);
	background: linear-gradient(97deg,
			rgba(255, 255, 255, 0.2) 0%,
			rgba(255, 255, 255, 0.8) 100%);
	box-shadow: 0 6px 18px -3px rgba(0, 0, 0, 0.04);
	backdrop-filter: blur(9rem);
	-webkit-backdrop-filter: blur(9rem);

	cursor: pointer;
	overflow: hidden;
}

.section1-container-bottom div,
.section1-container-bottom div img {
	transition: all 0.8s ease;
}

.section1-container-bottom div:nth-child(1) img {
	width: 114rem;
	height: auto;
}

.section1-container-bottom div:nth-child(3) img {
	width: 102rem;
	height: auto;
}

.section1-container-bottom div:nth-child(4) img {
	width: 120rem;
	height: auto;
}

.section1-container-bottom div:nth-child(2) img {
	width: 126rem;
	height: auto;
}

.section1-container-bottom .active {
	width: 200rem;
	height: 160rem;
	position: relative;

}

.section1-container-bottom .active img {
	transform: scale(1.25);
}

.section1-container-bottom .active::before {
	content: "";
	position: absolute;
	inset: 0;
	background: var(--ebc-brand-primary-burgundy);
	transform: scaleX(0);
	transform-origin: left;
	animation: slideFill 5s linear forwards;
	opacity: 0.05;
}

@keyframes slideFill {
	to {
		transform: scaleX(1);
	}
}

.section1-2 {
	padding: 35rem 0;
	position: relative;
	overflow: hidden;
}

.section1-2::before,
.section1-2::after {
	position: absolute;
	top: 0;
	content: "";
	height: 100%;
	width: 180rem;
	z-index: 999;
}

.section1-2::before {
	left: 0;
	background: linear-gradient(to right,
			/* 0% 透明度 */
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 1) 50%,
			rgba(255, 255, 255, 0.8) 60%,
			rgba(255, 255, 255, 0.7) 70%,
			rgba(255, 255, 255, 0.5) 80%,
			rgba(255, 255, 255, 0.3) 100%);
}

.section1-2::after {
	right: 0;
	background: linear-gradient(to left,
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 1) 50%,
			rgba(255, 255, 255, 0.8) 60%,
			rgba(255, 255, 255, 0.7) 70%,
			rgba(255, 255, 255, 0.5) 80%,
			rgba(255, 255, 255, 0.3) 100%);
}

.section1-2Swiper .item {
	padding-inline: 16px;
}

.section1-2 .swiperList .item .text1 {
	color: #9f734c;
	text-align: center;
	font-size: 20rem;
	font-weight: 600;
	line-height: normal;
	white-space: nowrap;
}

.section1-2 .swiperList .item .text2 {
	color: rgba(0, 0, 0, 0.48);
	text-align: center;
	font-size: 14rem;
	font-weight: 400;
	line-height: normal;
	/* margin-top: 12rem; */
	white-space: nowrap;
}

.section1-2 .swiperList .item {
	display: flex;
	align-items: center;
	width: fit-content;
	flex-shrink: 0;
}

.section1-2 .swiperList img {
	width: 45px;
	height: 45px;
}

#scene {
	padding: 160rem 0;

}

#scene .sticky-box {
	flex-direction: column;
}

@media screen and (max-width: 996px) {
	.section1-container-top .container-left .super_large-80_bold, .section1-container-top .container-left h1{
    font-size: 64rem;
    line-height: 80rem;
  }
	.section1-container-top .container-left .starLogo {
		transform: translateY(-24rem)
	}

	.animateBtn:hover img:first-child {
		width: 0;
	}

	.animateBtn:hover img:nth-child(2) {
		width: 40rem;
	}

	body {
		max-width: 100vw;
		overflow-x: hidden;
	}

	.en .section1 {
		height: 1300rem;
	}
	.section1-container-top .container-left .super_large-80_bold,
	.section1-container-top .container-left h1 {
		white-space: normal !important;
	}

	// .en .section1-swiper .slide-1 img {
	// 	margin-top: -50rem;
	// }

	.vi .section1-swiper .slide-1 img {
		margin-top: 0;
	}

	.en .section1-container-top .container-left:nth-child(1) .btnList a {
		display: block;
		max-width: calc(50% - 16rem);
	}

	.en .section1-container-top .container-left:nth-child(1) .btnList a>div {
		max-width: 100%;
	}

	.en .section1-container-top .container-left:nth-child(1) .btnList .btn {
		white-space: nowrap;
	}

	.en .section1-container-top .container-left:nth-child(1) .btnList .btn img {
		display: none;
	}

	.en .section1-swiper .slide-2 img {
		margin-top: 40rem;
	}

	.en .section1-container-top .container-left h1 {
		font-size: 52rem;
		line-height: 60rem;
	}

	.section1 {
		height: 1180rem;
		padding: 0 32rem 212rem;
		box-sizing: content-box;
		margin-top: -88rem;
		overflow: hidden;
	}

	.section1-bg,
	.section1-bg3,
	.section1-bg2 {
		height: 100%;
	}
 .section1-bg3{
      background: url("../assets/image/newHome/section1BgblueM.png") no-repeat;
      background-size: cover;
      background-position: center;
  }
	.section1-container-bottom {
		display: none !important;
	}

	.section1-container-top .container-left .tagList {
		justify-content: center;
	}

	.en .section1-container-top .container-left .tagList {
		margin-top: 40rem;
	}

	.section1-container-top {
		flex-direction: column;
	}

	.section1 .section1-container-top {
		padding: 152rem 0 0 !important;
		align-items: center !important;
		 position: relative;
    	z-index: 10;
    	overflow: visible;
	}

	.section1-container-top .container-left {
		text-align: center;
		max-width: 100%;
	}

	.section1-container-top .container-left .btn,
	.section1-container-top .container-left .btn1 {
		height: 96rem;
		line-height: 56rem;
		font-size: 32rem;
	}

	.animateBtn img {
		width: 40rem;
		height: 40rem;
	}

	.section1-container-top .container-left h2 {
		margin: 16rem 0 48rem;
	}

	.section1-container-top .container-left .dataList {
		justify-content: space-between;
		gap: 0;
		max-width: 1300rem;
		width: 90vw;
		box-sizing: border-box;
	}

	.section1-container-top .container-left .dataList .dataBox {
		flex: 1;
	}

	.section1-container-top .container-right {
		width: 95%;
		margin: auto;
	}

	.section1-swiper .slide-1 img {
		width: 686rem;
		margin: 0;
	}

	.section1-swiper .slide-2 img {
		width: 620rem;
	}

	.section1-swiper .slide-3 img {
		width: 630rem;
		margin-top: 20rem;
	}

	.section1-swiper .slide-4 img {
		width: 660rem;
		margin-top: 30rem;
	}

	.section1-swiper .swiper-slide {
		/* align-items: center; */
		display: flex;
		justify-content: center;
	}

	.btnList {
		position: absolute;
		left: 50%;
		 transform: translate(-50%, 90%);
    	bottom: 0;
		gap: 32rem;
		width: calc(100% - 64rem);
	}

	.section1-container-top .container-left .btnList>a,
	.section1-container-top .container-left .btnList .btn,
	.section1-container-top .container-left .btnList .btn1 {
		flex: 1;
		margin: 0;
	}

	.section1-container-top .container-left .btn {
		width: 100%;
		margin-top: 0;
	}

	.section1-container-top .container-left .tagList div {
		padding: 8rem 32rem;
		font-size: 28rem;
		border-radius: 16rem;
	}

	/* .section1-container-top .container-left .btn1 {
    margin: 16rem 0 0;
  } */
	.section1-container-top .container-left {
		position: static;
	}

	.section1-container-top .container-left:nth-child(1) .btnList .btn1 {
		width: 100%;
	}

	.section1-container-top .container-left:nth-child(1) .btnList a:nth-child(1) {
		order: 2;
	}

	.section1-container-bottom-mobile {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 48rem;
		width: calc(100% - 64rem);
		display: flex;
		justify-content: center;
		gap: 16rem;
	}

	.section1-container-bottom-mobile div {
		border-radius: var(--ebc-corner-radius-full);
		width: 6%;
		height: 4rem;
		max-height: 10rem;
		background-color: var(--ebc-functional-active-bg);
		opacity: 0.5;
	}

	.section1-container-bottom-mobile .active {
		opacity: 1;
		width: 12%;
		background-color: var(--ebc-functional-active-normal);
	}

	.section1-swiper {
		pointer-events: initial;
	}

	.section1-2::before,
	.section1-2::after {
		all: unset !important;
	}

	.section1-2 {
		padding: 30rem 0 60rem;
	}

	.section1-2 .swiperList {
		margin-top: 32rem;
		/* transition: transform 0.3s linear; */
	}

	.section1-2 .swiperList .item {
		padding: 0 16px;
	}

	.section1-2 .swiperList .item .text1 {
		color: #9f734c;
		text-align: center;
		font-size: 32rem;
		font-weight: 500;
		line-height: normal;
		white-space: nowrap;
		line-height: 48rem;
	}

	.section1-2 .swiperList .item .text2 {
		color: rgba(0, 0, 0, 0.65);
		text-align: center;
		font-size: 24rem;
		font-weight: 400;
		line-height: 40rem;
		margin-top: -8rem;
	}

	.section1-2 .swiperList img {
		width: 64rem;
		height: 64rem;
	}

}

@media (min-width: 700px) and (max-width: 996px) {

	.section1-swiper .slide-1 img,
	.section1-swiper .slide-2 img,
	.section1-swiper .slide-4 img {
		margin-top: 5vw !important;
	}
}

.section2 h2 {
	text-align: center;
	color: var(--ebc-text-primary);
}

.section2 h3 {
	text-align: center;
	color: var(--ebc-text-secondary);
	margin: 12rem 0 84rem;
}

.scene {
	position: relative;
	padding: 160rem 0
}

.section2 .contentBoxInner .tabList {
	width: 800rem;
	height: 62rem;
	padding: 5rem;
	gap: 5rem;
	border-radius: var(--ebc-corner-radius-full);
	background: var(--ebc-neutral-bg_b);
	color: var(--ebc-text-secondary);
	font-size: 16rem;
	font-weight: var(--ebc-fontweights-2);
	margin-bottom: 30rem;
}

.section2 .contentBoxInner .tabList div {
	flex: 1 1 0;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}

.section2 .contentBoxInner .tabList .active {
	color: var(--ebc-text-primary);
	font-weight: var(--ebc-fontweights-1);
	background: var(--ebc-basecolor-white-100);
	position: relative;
	border-radius: var(--ebc-corner-radius-full);
	overflow: hidden;
	clip-path: inset(0);
	/* 添加 clip-path */


}

/* .section2 .contentBoxInner .tabList .active:before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--ebc-brand-primary-burgundy);
  transform: scaleX(0);
  transform-origin: left;
  animation: slideFill 20s ease forwards;
  opacity: 0.1;
} */
.section2 .contentBoxInner .tabList .pausedanimated::before {
	animation-play-state: paused;
}

.section2 .index-section1-list-tr {
	width: 800rem;
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	padding: 16rem 0;
}


.section2 .index-section1-list-tr:last-child {
	border: 0;
}

.section2 .index-section1-list-th {
	font-size: 16rem;
	font-weight: var(--ebc-fontweights-2);
	color: var(--ebc-text-secondary);
}

.section2 .index-section1-list-td img {
	width: 40rem;
	height: 40rem;
	/* margin-left: 69rem; */
}

.section2 .index-section1-list-td {
	font-size: 20rem;
	font-weight: var(--ebc-fontweights-1);
	color: var(--ebc-text-primary);
	text-align: center;
}

.section2 .index-section1-list-td:nth-child(1) span {
	font-size: 20rem;
}

.section2 .index-section1-list-td span {
	font-size: 12rem;
	font-weight: var(--ebc-fontweights-1);
}

.section2 .index-section1-list-td.green {
	color: #00ac47;
}

.section2 .index-section1-list-td.red {
	color: #e60004;
}

.section2 .index-section1-list-td:first-child {
	gap: 16rem;
	text-indent: 0rem !important;
}

.section2 .index-section1-list-th:first-child,
.section2 .index-section1-list-td:first-child {
	flex: 10;
	/* text-indent: 69rem; */
}

.section2 .index-section1-list-td:nth-child(2),
.section2 .index-section1-list-td:nth-child(3),
.section2 .index-section1-list-td:nth-child(5),
.section2 .index-section1-list-th:nth-child(2),
.section2 .index-section1-list-th:nth-child(3),
.section2 .index-section1-list-th:nth-child(5) {
	flex: 5;
}

.section2 .index-section1-list-td:nth-child(4),
.section2 .index-section1-list-th:nth-child(4) {
	flex: 3;
}

.contentBox {
	padding: 17rem 137rem 45rem;
}

.contentBg {
	background: url("../assets/image/newHome/computerBg.png") no-repeat;
	background-size: 100% 100%;
	box-sizing: border-box;

	transform-origin: 50% 0;
	position: relative;
	/* overflow: hidden; */
	/* will-change: transform; 
  transition: transform 250ms ease-out ; */
	/* transform: scale(0.7, 0.6); */
}

.contentBg .contentBoxInner:before {
	position: absolute;
	content: "";
	height: 23px;
	width: 100%;
	background: url("../assets/image/newHome/chromeAddress.png") no-repeat;
	background-size: 100% 100%;
	top: 0;
}

.contentBoxInner {
	background: var(--ebc-basecolor-white-100);
	padding: 55rem 103rem 40rem;
	position: relative;
	border-radius: var(--ebc-corner-radius-rc12);
	flex-direction: column;
}

.contentBoxInner {
	position: relative;
	overflow: hidden;
}

#locationEle #section2PointPC:hover .locationHoverBox {
	display: flex;
}

.pointCanvasContainer .locationX,
.pointCanvasContainer .locationY {
	color: var(--ebc-basecolor-white-100);
}

#locationEle #section2PointPC {
	position: absolute;
	right: 28%;
    top: 26%;
    z-index: 999;
    width: 36rem;
    height: 36rem;
	border-radius: 50%;
	opacity: 0;
	transition: opacity 0.5s;
}

.showSection2PointPC {
	opacity: 1 !important;
}

#locationEle #section2PointPC .ring {
	position: absolute;
	inset: 0;
	 width: 12px;
    height: 12px;
    left:50%;
    top:50%;
	background: rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	animation: scaleRing 2s ease-in-out infinite;
	transform-origin: 50% 50%;
}

#locationEle #section2PointPC .dot {
	position: absolute;
	inset: 0;
	 width: 12px;
    height: 12px;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
	border-radius: 50%;
	object-fit: cover;
	background-color: #fff;
}

@keyframes scaleRing {
	0% {
		transform:translate(-50%,-50%) scale(1.8);
	}

	50% {
		transform:translate(-50%,-50%) scale(2.2);
	}

	100% {
		transform:translate(-50%,-50%) scale(1.8);
	}
}


.pointCanvasContainer .locationY {
	position: absolute;
	top: 50rem;
	left: 140rem;
}

.pointCanvasContainer .locationX {
	position: absolute;
	right: 14%;
	bottom: 14%;
}

.pointCanvasContainer .canvasLegend {
	position: absolute;
	bottom: 40rem;
	gap: 20rem;
	left: 50%;
	transform: translateX(-50%);

}

.pointCanvasContainer .canvasLegend>div .desc {
	font-size: 14rem;
	font-weight: 400;
	line-height: normal;
	color: var(--ebc-basecolor-white-100);
}

.ar .pointCanvasContainer .canvasLegend>div .point {
	margin-left: 8rem;
}

.pointCanvasContainer .canvasLegend>div .point {
	width: 12rem;
	height: 12rem;
	margin-right: 8rem;
	border-radius: 50%;
}

.pointCanvasContainer .canvasLegend>div:first-child .point {

	background: var(--ebc-brand-accent-coral);
}

.pointCanvasContainer .canvasLegend>div:nth-child(2) .point {
	background: var(--ebc-neutral-lignt_gold);
}


/* .contentBoxInner .locationHoverBox .animateBtn svg {
  width: 0rem;
  height: 20rem;
}
.contentBoxInner .locationHoverBox .animateBtn:hover svg {
  width: 20rem;
  margin-right: 5rem;
} */
/* .contentBoxInner .location {
  position: absolute;
  transition: transform .25s ;
  will-change: transform;
  width: 100%;
  height: 100%;
  transform: translateY(110%);
  z-index: 2;
  background:#2c2c2c;
} */

.scene2 {
	padding: 160rem 0 300rem;
	position: sticky;
	top: 0;
	perspective: 1000px;
	transform-style: preserve-3d;
}

.scene2 .scene2Container {
	transition: transform 0.5s ease, opacity 0.5s ease
}

.scene2 h2 {
	margin-bottom: 12rem;
}

.scene2 h3 {
	margin-bottom: 84rem;
}

.scene2 h2,
.scene2 h3 {
	text-align: center;
}

.scene2 #locationEle {
	width: 1050rem;
	height: 600rem;
	margin: 0 -40rem;
	padding: 16rem 120rem 40rem;
	background: url("../assets/image/newHome/computerBg.png") no-repeat;
	background-size: 100% 100%;

}

.scene2 #locationEle .locationContainer {
	width: 100%;
	height: 100%;
	position: relative;
	background: #2c2c2c;
}

.scene2 #locationEle .locationContainer img {
	width: 563rem;
	height: 390rem;
	position: absolute;
	left: 145rem;
	top: 77rem;
}

.scene2 #locationEle canvas {
	position: absolute;
	left: 210rem;
	bottom: 110rem;
	width: 48%;
	height: auto;
}

.scene2 .locationHoverBox {
	display: none;
	width: 280rem;
	min-height: 150rem;
	color: var(--ebc-text-primary);
	padding: 24rem 20rem;
	font-size: 14rem;
	font-style: normal;
	font-weight: 400;
	line-height: 22rem;
	border-radius: var(--ebc-corner-radius-rc12);
	border: 1px solid rgba(255, 255, 255, 0.2);
	background: linear-gradient(143deg,
			rgba(255, 255, 255, 0.9) 0%,
			rgba(255, 255, 255, 0.8) 100%);
	box-shadow: 0 8rem 20rem 0 rgba(0, 0, 0, 0.2);
	backdrop-filter: blur(10rem);
	-webkit-backdrop-filter: blur(10rem);

	/* position: absolute; */
	z-index: 99999999;
	transform: translate(-5%, -50%);
	flex-direction: column;
}

.scene2 .locationHoverBox .animateBtn {
	background: var(--ebc-basecolor-active-500);
	border-radius: var(--ebc-corner-radius-full);
	width: fit-content;
	padding: 0 24rem;
	height: 32rem;
	color: var(--ebc-text-primary_white);
	margin-top: 10rem;
}

.scene2 .locationHoverBox .animateBtn:hover {
	background: var(--ebc-basecolor-active-400);
}

.scene2>div {
	position: relative;
	max-width: 1100rem;
	margin-inline: auto;
}

.scene2 .leftPart {
	position: absolute;
	left: 50rem;
	transform: translateX(-100%)
}

.scene2 .rightPart {
	position: absolute;
	right: 50rem;
	transform: translateX(100%)
}

.scene2 a {
	width: fit-content;
	margin: 90rem auto 0;
	display: block;
}

.scene2 .locationHoverBox a {
	margin-top: 0;
}

.scene .bottomPart {
	/* transform:scale(1.667) tran */
	color: var(--ebc-basecolor-white-100);
}

.contentBoxStep2 {
	margin-bottom: 85rem;
}

.contentBoxStep2 div:nth-child(2) {
	color: var(--ebc-text-secondary);
	margin-top: 5rem;
}

.contentBoxStep2 div:nth-child(1) {
	color: #2c2c2c;
	font-size: 52rem;
	font-weight: var(--ebc-fontweights-0);
}

.section-animateBtn {
	padding: 12rem 38rem;
	gap: 4rem;
	color: var(--ebc-basecolor-white-100);
	background: var(--ebc-basecolor-active-500);
	transition: width 0.6s ease;
	border-radius: var(--ebc-corner-radius-full);
	line-height: initial;
	cursor: pointer;
	box-sizing: border-box;
}

.section-animateBtn:hover {
	background: var(--ebc-basecolor-active-400);
}

.section-animateBtn svg:first-child {
	width: 0rem;
	height: 20rem;
}

.section-animateBtn svg:nth-child(2) {
	width: 20rem;
	height: 20rem;
}

/* .section-animateBtn svg {
  transition: width 0.6s ease;
} */
/* .section-animateBtn:hover {
  background: var(--ebc-basecolor-active-300);
} */
/* .section-animateBtn:hover svg:first-child {
  width: 20rem;
}
.section-animateBtn:hover svg:nth-child(2) {
  width: 0rem;
}
 */

@media screen and (max-width: 996px) {
	.sticky-box {
		display: none;
	}

	.section2 .contentBox {
		display: none;
		max-width: 99vw;
	}

	.section2 {
		padding: 80rem 0 160rem;
	}

	section2 h2 {
		color: var(--ebc-text-primary);
		margin-bottom: 16rem;
	}

	.section2 h3 {
		color: var(--ebc-text-secondary);
		margin-bottom: 80rem;
	}

	.section2 .tab-wrapper {
		width: 100%;
		/* 可视宽度 */
		overflow-x: auto;
		/* 横滑 */
		scroll-behavior: smooth;
		/* 平滑 */
		-webkit-overflow-scrolling: touch;
		/* iOS 弹性 */
	}

	.section2 .tab-wrapper::-webkit-scrollbar {
		display: none;
	}

	.section2 .tab-scroll {
		display: inline-flex;
		/* 一行 tab，不换行 */
		gap: 16rem;
		white-space: nowrap;
		min-width: 100%;
		margin-bottom: 48rem;
		padding-inline: 32rem;
	}

	/* .section2 .tab:first-child {
    margin-left: 16rem;
  } */
	.section2 .tab {
		flex: 0 0 auto;
		padding: 8px 16px;
		color: var(--ebc-text-secondary);
		background: var(--ebc-neutral-bg_b);
		border-radius: var(--ebc-corner-radius-full);
		font-weight: 400;
	}

	.section2 .tab.active {
		background: var(--ebc-basecolor-active-500);
		color: var(--ebc-text-primary_white);
		font-weight: 500;
	}

	.section2 .tableData {
		width: calc(100% - 64rem);
		margin: 0 auto 32rem;
	}

	.section2 .table-tr {
		margin-bottom: 32rem;
		padding: 0 32rem;
		border-radius: var(--ebc-corner-radius-rc16);
		background: var(--ebc-neutral-bg_b);
	}

	.section2 .table-tr .top {
		padding: 32rem 0;
		border-bottom: .5px solid var(--ebc-neutral-divider_medium);
	}

	.section2 .table-tr .top img {
		width: 48rem;
		height: 48rem;
		margin-right: 16rem;
	}

	.section2 .table-tr .bottom {
		padding: 32rem 0;
	}

	.section2 .table-tr .bottom div {
		flex: 1;
	}

	.section2 .table-tr .value {
		color: var(--ebc-text-primary);
	}

	.section2 .table-tr .value span {
		font-size: 24rem;
		line-height: 24rem;
	}

	.section2 .table-tr .green {
		color: #00ac47;
	}

	.section2 .table-tr .red {
		color: #e60004;
	}

	.section2 .bottomBtn {
		margin: 80rem auto 0;
	}

	.section2-2 {
		background: #2c2c2c;
		padding: 160rem 32rem 320rem;
		position: sticky;
	}

	.section2-2 h2 {
		color: var(--ebc-text-primary_white);
		margin-bottom: 16rem;
	}

	.section2-2 h3 {
		color: var(--ebc-text-secondary_white);
		margin-bottom: 80rem;
	}

	.section2-2 .location {
		position: relative;
		width: 100%;
		aspect-ratio: 1.5
	}

	.section2-2 .location #section2Point {
		position: absolute;
		right: 24%;
		top: 26%;
		z-index: 999;
		width: 50rem;
		height: 50rem;
		border-radius: 50%;
	}

	.section2-2 .section2ConfirmPopover {
		display: none;
		border-radius: var(--ebc-corner-radius-rc24);
		background: #fff;
		box-shadow: 0 10px 32px 0 rgba(0, 0, 0, 0.1);
		width: 622rem;
		padding: 110rem 32rem 32rem;
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 9999999;
		transform: translate(-50%, -50%);
	}

	.section2-2 .section2ConfirmPopover svg {
		position: absolute;
		top: 32rem;
		right: 32rem;
		width: 48rem;
		height: 48rem;
	}

	.showConfirmPopover {
		display: block !important;
		animation: popoverShow .3s ease-in-out;
	}


	@keyframes popoverShow {
		0% {
			transform: translate(-50%, -50%) scale(1.1);
		}

		100% {
			transform: translate(-50%, -50%) scale(1);
		}
	}

	.section2-2 .section2ConfirmPopover .word {
		margin-bottom: 64rem;
		color: var(--ebc-text-secondary);
	}

	.section2-2 .section2ConfirmPopover .btn img {
		width: 32rem;
		height: 32rem;
	}

	.ring {
		position: absolute;
		left:50%;
    top:50%;
    width: 16rem;
    height: 16rem;
		background: rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		animation: scaleRing 2s ease-in-out infinite;
		transform-origin: 50% 50%;
	}

	.dot {
		position: absolute;
		 width: 16rem;
    height: 16rem;
    left:50%;
    top:50%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
		object-fit: cover;
		background-color: #fff;
	}

	@keyframes scaleRing {
		0% {
			transform:translate(-50%, -50%) scale(1.8);
		}

		50% {
			transform:translate(-50%, -50%) scale(2.2);
		}

		100% {
			transform:translate(-50%, -50%) scale(1.8);
		}
	}

	.section2-2 .location canvas {
		position: absolute;
		left: 16%;
		top: 25%;
		width: 62%;
		height: 61%;
	}

	.section2-2 .location .topWord {
		color: #fff;
		position: absolute;
		top: 0;
		left: 0;
	}

	.section2-2 .location .rightWord {
		color: #fff;
		position: absolute;
		bottom: 0rem;
		right: 0;
	}

	.section2-2 .locationBottom {
		gap: 48rem;
		margin: 48rem 0 16rem;
	}

	.section2-2 .locationBottom div {
		color: #fff;
	}

	.ar .section2-2 .locationBottom div .spot {
		margin-left: 16rem;
	}

	.section2-2 .locationBottom div .spot {
		width: 24rem;
		height: 24rem;
		border-radius: var(--ebc-corner-radius-full);
		margin-right: 16rem;
	}

	.section2-2 .locationBottom div:nth-child(1) .spot {
		background-color: var(--ebc-brand-accent-coral);
	}

	.section2-2 .locationBottom div:nth-child(2) .spot {
		background-color: var(--ebc-neutral-lignt_gold);
	}

	.section2-2 .location img {
		width: 100%;
		height: 100%;
	}

	.section2-2 .dataList {
		margin: 0rem 0 80rem;
	}

	.section2-2 .dataList .dataItem {
		margin-top: 48rem;
		width: 100%;
	}

	.section2-2 .dataList .dataItem .topNum {
		margin-bottom: 6rem;
		color: var(--ebc-text-primary_white);
	}

	.section2-2 .dataList .dataItem .bottomDesc {
		color: var(--ebc-text-secondary_white);
	}

	.section3 .btn,
	.section4 .btn,
	.section5 .btn,
	.section2 .bottomBtn,
	.section2-2 .btn {
		color: var(--ebc-text-primary_white);
		min-width: 330rem;
		padding: 0 24rem;
		width: fit-content;
		height: 80rem;
		margin-inline: auto;
		border-radius: var(--ebc-corner-radius-full);
		background: var(--ebc-basecolor-active-500);
		gap: 8rem;
	}
}



.en .section3 .cardBox .left {
	height: 800rem;
}

.en .section3 .cardBox .right {
	height: 800rem;
}

.ru .section3 .cardBox .left {
	height: 850rem;
}

.ru .section3 .cardBox .right {
	height: 850rem;
}

.en .section3 .card h4 {
	max-width: 85%;
}

.section3 {
	padding: 160rem 0;
	/* position: sticky; */
	/* top: -500rem; */
	/* z-index: 0; */
	overflow: hidden;
	transform-origin: 50% 100%;
	background: var(--ebc-neutral-bg_b);
	/* perspective: 1000px; */
}

.section3Container {
	transition: transform 0.5s ease, opacity 0.5s ease;
}

.section3 h2 {
	color: var(--ebc-text-primary);
}
.scene2 h3,
.section3 h3 {
	margin: 12rem 0 84rem;
	color: var(--ebc-text-secondary);
}

.section3 .cardBox {
	gap: 24rem;
}

.section3 .cardBox .left {
	width: 588rem;
	height: 704rem;
	gap: 24rem;
	flex-direction: column;
	align-items: normal !important;

}

.section3 .cardBox .right {
	width: 588rem;
	height: 704rem;
	gap: 24rem;
	align-items: normal !important;

}

.section3 .cardBox .left .card,
.section3 .cardBox .right .card {
	border-radius: var(--ebc-corner-radius-rc16);
	/* background: var(--ebc-neutral-bg_a); */
	position: relative;
	flex: 1;
	background: transparent;
	border: 0;
	/* overflow: hidden; */
}

.ar .section3 .cardBox .left .card .rightIcon,
.ar .section3 .cardBox .right .card .rightIcon {
	left: 24rem !important;
	right: unset;
}

.section3 .cardBox .left .card .rightIcon,
.section3 .cardBox .right .card .rightIcon {
	position: absolute;
	top: 24rem;
	right: 24rem;
	width: 40rem;
	height: 40rem;
	z-index: 0;
	opacity: 1;
	filter: grayscale(0%);
}

.section3 .card1 .logoList {
	margin-top: 4rem;
}

.section3 .card1 .logoList .item {
	width: 49%;
	height: 110rem;
}

.section3 .card1 .logoList .item:nth-child(1) {
	border-right: 1px solid rgba(0, 0, 0, 0.03);
	border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

.section3 .card1 .logoList .item:nth-child(4) {
	border-left: 1px solid rgba(0, 0, 0, 0.03);
	border-top: 1px solid rgba(0, 0, 0, 0.03);
}

.section3 .card1 .logoList .item:nth-child(1) img {
	width: 201rem;
	height: auto;
}

.section3 .card1 .logoList .item:nth-child(2) img {
	width: 193rem;
	height: auto;
	opacity: 1;
}

.section3 .card1 .logoList .item:nth-child(3) img {
	width: 117rem;
	height: auto;
}

.section3 .card1 .logoList .item:nth-child(4) img {
	width: 160rem;
	height: auto;
	opacity: 1;
}

.section3 .flip-box {
	perspective: 1000px;

}

.section3 .flipper {
	position: relative;
	width: 100%;
	height: 100%;
	transition: transform .8s ease-in-out;
	transform-style: preserve-3d;
}

.section3 .front,
.section3 .back {
	position: absolute;
	inset: 0;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;

	padding: 30rem;
	border-radius: var(--ebc-corner-radius-rc24);
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.section3 .front .jgList,
.section3 .front .logoList{
	margin: auto 0;
}

.section3 .front {
	background: var(--ebc-neutral-bg_a);
}

.section3 .front .rightTopBg {
	position: absolute;
	width: 581.778rem;
	height: 374.264rem;
	transform: rotate(-8deg);
	right: -75rem;
	top: 0;
	pointer-events: none;
}

.section3 .back {
	/* background: var(--ebc-brand-primary-burgundy); */
	background-color: #FFF;
	transform: rotateY(180deg);
	flex-direction: column;
}

.section3 .back h4 {
	color: var(--ebc-text-primary_white);
	margin-bottom: 32rem;
}

.section3 .back article {
	color: var(--ebc-text-secondary);
	margin-top: 30rem;
}


.section3 .back h4 {
	margin-bottom: 0rem;
	color: var(--ebc-brand-primary-burgundy);
}

.section3 .back img {
	width: 40rem;
	height: 40rem;
	position: absolute;
	right: 24rem;
	bottom: 24rem;
}

.section3 .card2 img,
.section3 .card1 img {
	filter: grayscale(100%);
	opacity: 0.6;
}

.section3 .card1 .card1Logo4 img {
	filter: brightness(0.6) contrast(0) saturate(0);
}

.section3 .card1 img:hover,
.section3 .card2 .brandListLine div:hover img {
	filter: grayscale(0%) !important;
	opacity: 1 !important;
}

.section3 .flip-box.flipped {
	z-index: 999999999;
}

.section3 .flip-box.flipped .flipper {
	transform: rotateY(180deg);
	position: relative;
	z-index: 3
}

.section3 .flip-box.flipped .back .rightIcon {
	transform: rotateZ(45deg);
}

.section3 .card2 .brandList.pc {
	transform: scale(1.2) translateX(15rem)
}

.section3 .card2 .brandListLine {
	gap: 15rem;
}

.section3 .card2 .front h4 {
	padding-left: 30rem;
	padding-right: 30rem;
	margin-bottom: 40rem;
}

.en .section3 .card2 .front h4 {
	margin-bottom: 60rem;
}

.section3 .card3 .front h4 {
	margin-bottom: 60rem;
}

.en .section3 .card3 .front h4 {
	margin-bottom: 80rem;
}

.section3 .card2 .front {
	padding-inline: 0;
}

.section3 .card2 .brandListLine div {
	width: 80rem;
	height: 100rem;
	background: url(../assets/image/newHome/section3Card2BrandIconBg.svg);
	background-size: 100% 100%;
	flex-shrink: 0;
	transition: transform .5s;
}

.section3 .card2 .brandListLine a {
	text-align: center;
}
.section3 .card2 .brandListLine:nth-child(2) {
  margin-left: -45rem;
  margin-top: -20rem;
}
.ar .section3 .card2 .brandListLine:nth-child(2) {
  margin-right: 45rem;
}
.section3 .card2 .brandListLine:nth-child(2) {
	margin-left: -40rem;
	margin-top: -25rem;
}

.section3 .card2 .brandListLine div:hover {
	background: url(../assets/image/newHome/section3Card2BrandIconBgA.svg);
	background-size: 100% 100%;
	/* opacity: 0.8; */
	filter: drop-shadow(0 10px 32px rgba(0, 0, 0, 0.4));
	transform: scale(1.2);
}

.section3 .card2 .brandListLine div img {
	max-width: 80%;
	max-height: 80%;
	height: auto;
}

.section3 .card2 .brandListLine:nth-child(1) div:nth-child(3) img {
	max-width: 100%;
  	max-height: 100%;
	opacity: 1;
}

.section3 .card2 .brandListLine:nth-child(2) div:nth-child(4) img {
	max-width: 55%;
  	max-height: 55%;
	height: auto;
}

@media (max-width: 1440px) {
	.section3 .card2 .brandListLine div img {
		max-width: 80%;
		max-height: 80%;
		height: auto;
	}

	.section3 .card2 .brandListLine:nth-child(2) div:nth-child(2) img,
	.section3 .card2 .brandListLine:nth-child(2) div:nth-child(4) img {
		max-width: 62%;
		max-height: 62%;
		height: auto;
	}
}

.es .section3 .card3 .jgItem {
	padding-left: 15rem;
}

.section3 .card3 .jgItem {
	gap: 32rem;
	margin-bottom: 72rem;
	padding-left: 32rem;
}
.ja .section3 .card3 .jgItem{
	flex-direction: column;
}
.section3 .card3 .jgItem .title {
	color: var(--ebc-text-primary);
	margin-bottom: 8rem;
}
.section3 .card3 .jgItem .title:hover{
	color:var(--ebc-basecolor-active-500)
}
.section3 .card3 .jgItem .title:hover svg path {
	stroke: var(--ebc-basecolor-active-500);
}
.ja .section3 .card3 .jgItem .title {
	font-size: 24rem;
	line-height: 32rem;
	margin-bottom: 24rem;
	text-align: center;
}

.section3 .card3 .jgItem .title svg {
	width: 16rem;
	height: 16rem;
	transform: translateY(-2rem);
}

.ja .section3 .card3 .jgItem .title svg {
	width: 24rem;
	height: 24rem;
	margin-left: 4rem;
	// transform: translateY(2rem)
}

.section3 .card3 .jgItem .desc {
	color: var(--ebc-text-secondary);
	margin-bottom: 3rem;
}

.ja .section3 .card3 .jgItem .desc {
	margin-bottom: 8rem;
	text-align: center;
}

.section3 .card3 .jgItem img {
	width: 80rem;
	height: 80rem;
}

.ja .section3 .card3 .jgList img {
	width: 180rem;
	height: 180rem;
}

.section3 .section3Container>a {
	margin: 80rem auto 0;
	width: fit-content;
	display: block;
}

@media (max-width: 996px) {
	.section3 .card2 .brandList {
        transform: translateX(-25px);
    }
	 .section2 h2,.section2 h3,
  .section3 h2,.section3 h3,
  .scene2  h2,.scene2  h3,
  .section4 h2,.section4 h3,
  .section5 h2,.section5 h3{
    padding:0 32rem
  }
  .section2 .btn img,
  .section2 .bottomBtn img,
  .section4 .btn img,
  .section5 .btn img,
  .section2-2 .btn img,
  .section3 .btn img{
    display: none;
  }
	.en .section3 .cardBox .right{
		height: 1400rem;
	}
	.en .section3 .cardBox .left {
		height: 1600rem
	}

	.en .section3 .cardBox .left .logoList {
		margin-top: 0rem;
		height: calc(100% - 80rem);
		align-items: center;
	}

	.mn .section3 .cardBox .left,
	.es .section3 .cardBox .left,
	.pt .section3 .cardBox .left {
		height: 1900rem
	}

	.ru .section3 .cardBox .left {
		height: 2100rem;
	}

	.section3 {
		padding: 160rem 0;
		top: -2200rem;
	}

	.section3 h3 {
		margin: 16rem 0 80rem;
	}

	.section3 .cardBox {
		flex-direction: column;
		gap: 32rem;
	}

	.section3 .cardBox .left {
		gap: 32rem;
	}

	.section3 .cardBox .left,
	.section3 .cardBox .right {
		width: 686rem;
		height: initial;
	}

	.section3 .cardBox .left {
		order: 2
	}

	.ja .section3 .cardBox .right {
		height: 900rem;
	}

	.section3 .cardBox .card1 .flipper {
		height: 715rem;
	}

	.section3 .cardBox .card2 .flipper {
		height: 710rem;
	}

	.section3 .cardBox .card3 .flipper {
		height: 1200rem;
	}

	.en .section3 .cardBox .card1 .flipper,
	.en .section3 .cardBox .card2 .flipper,
	.en .section3 .cardBox .card3 .flipper {
		height: 100%;
	}

	.section3 .card1 .logoList .item:nth-child(4) {
		border: 0;
	}

	.section3 .card1 .logoList .item:nth-child(1),
	.section3 .card1 .logoList .item:nth-child(2),
	.section3 .card1 .logoList .item:nth-child(3) {
		border: 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.03);
	}

	/* .section3 .card3 h4,
  .section3 .card2 h4,
  .section3 .card1 h4 {
    text-align: center;
  } */
	.section3 .card1 .logoList .item:nth-child(1) {
		order: 1;
	}

	.section3 .card1 .logoList .item:nth-child(3) {
		order: 2;
	}

	.section3 .card1 .logoList .item:nth-child(2) {
		order: 3;
	}

	.section3 .card1 .logoList .item:nth-child(4) {
		order: 4;
	}

	.section3 .card1 .logoList .item:nth-child(1) img {
		width: 306rem;
	}

	.section3 .card1 .logoList .item:nth-child(3) img {
		width: 190rem;
	}

	.section3 .card1 .logoList .item:nth-child(2) img {
		width: 298rem;
	}

	.section3 .card1 .logoList .item:nth-child(4) img {
		width: 182rem;
	}

	.section3 .card1 .logoList .item {
		width: 100%;
		height: auto;
		padding: 40rem 0;
	}

	.section3 .card1 img,
	.section3 .card2 img {
		filter: grayscale(0%) !important;
		opacity: 1;
	}

	.section3 .front,
	.section3 .back {
		padding: 40rem 32rem 32rem;
		box-sizing: border-box;
	}

	.ar .section3 .cardBox .left .card .rightIcon,
	.ar .section3 .cardBox .right .card .rightIcon {
		left: 32rem !important;
		right: unset;
	}

	.section3 .cardBox .left .card .rightIcon,
	.section3 .cardBox .right .card .rightIcon {
		position: absolute;
		 width: 70rem;
    height: 70rem;
		top: 24rem;
		right: 32rem;
		z-index: 0;
	}

	.section3 .card2 .brandListLine {
		gap: 8rem;
		margin:5rem 0 0;
	}

	.section3 .card2 .brandListLine div {
		width: 175rem;
		height: 175rem;
	}

	.section3 .card2 .brandListLine div:hover {
		background: url('/assets/image/newHome/section3Card2BrandIconBg.svg');
		background-size: 100% 100%;
		filter: none;
	}

	.section3 .card2 .brandListLine:nth-child(1),
	.section3 .card2 .brandListLine:nth-child(3) {
		margin-left: -150rem;
	}

	.section3 .card2 .brandListLine:nth-child(2),
	.section3 .card2 .brandListLine:nth-child(3) {
		margin-top: 0rem;
	}

	.section3 .card2 .brandListLine:nth-child(2) {
		margin-left: -65rem;
	}

	.section3 .card2 .brandListLine:nth-child(2) div:nth-child(3) {
		background: url('../assets/image/newHome/section3Card2BrandIconBgA.svg');
		background-size: 100% 100%;
		filter: drop-shadow(0 10px 32px rgba(0, 0, 0, 0.4));
	}

	.section3 .card2 .brandListLine div img {
		max-width: 75%;
    	max-height: 75%;
		height: auto;
	}
	 .section3 .card2 .brandListLine:nth-child(2) div:nth-child(2) img{
    max-width: 70%;
    max-height: 70%
  }
  .section3 .card2 .brandListLine:nth-child(1) div:nth-child(3) img{
    max-width: 85%;
    max-height: 85%
  }
	.section3 .card2 .brandListLine:nth-child(2) div:nth-child(3) img {
		max-width: 50%;
		max-height: 50%;
	}

	.section3 .front .rightTopBg {
		width: 672rem;
		height: 432rem;
	}
 .section3 .card2 .brandListLine:nth-child(2) div:nth-child(4) img{
    max-width: 80%;
    max-height: 80%;
  }

	.section3 .card3 .jgItem {
		gap: 16rem;
		padding-left: 0;
		margin-bottom: 64rem;
		flex-direction: column;
		align-items: flex-start !important;
	}

	.ja .section3 .card3 .jgItem {
		align-items: center !important;
	}

	.section3 .card3 .jgItem img {
		width: 80rem;
		height: 80rem;
	}

	.ja .section3 .card3 .jgItem .title svg,
	.section3 .card3 .jgItem .title svg {
		width: 24rem;
		height: 24rem;
		margin-left: 4rem;
	}
.ja .section3 .card3 .jgItem .title{
	font-size: 32rem;
}
.ja .section3 .card3 .jgItem .desc {
	font-size: 24rem;
	line-height: 40rem;
}
	.section3 .btn {
		margin-top: 80rem;
	}

	.section3 .card .front h4 {
		max-width: 85%;
	}

	.section3 .card2 .front h4 {
		padding-left: 32rem;
	}

	.section3 .card3 .front h4 {
		margin-bottom: 48rem;
	}
}

.section4 {
	padding: 160rem 0 30rem;
	background: url("../assets/image/newHome/earthBg.jpg") no-repeat;
	background-position: center;
	background-size: cover;
	border-radius: var(--ebc-corner-radius-rc24);
	overflow: hidden;
	position: relative;
	/* z-index:10 */
}

.section4 h2 {
	margin-bottom: 12rem;
	color: var(--ebc-text-primary_white);
}

.section4 h3 {
	color: var(--ebc-text-secondary_white);
}

.section4 .container {
	position: relative;
	width: 1050px;
	height: 1050px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 20rem auto 0;
}
.section4Tip{
  text-align: center;
  color: var(--ebc-text-tertiary_white);
  margin-top: 34rem;
}
@media screen and (max-width: 1440px) {
	.section4 .container {
		width: 700px;
		height: 700px
	}
}

.section4 #earth-container {
	width: 100%;
	height: 100%;
	position: relative;
}

.section4 #earth-container canvas {
	margin: 0 auto;
}

.section4 #overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 10;
}


.section4 .section4Bottom {
	margin-top: 80rem;
	gap: 80rem;
	margin-inline:88rem
}

.section4 .section4Bottom .top {
	color: #fff;
	margin-bottom: 8rem;
}

.section4 .section4Bottom .bottom {
	color: var(--ebc-text-secondary_white);
}

.section4 .danwei {
	font-size: 42rem;
}

.formPopup {
	border-radius: var(--ebc-corner-radius-rc24);
	background: var(--ebc-basecolor-white-100);
	box-shadow: 20px 40px 60px 0 rgba(0, 0, 0, 0.10);
	width: 560rem;
	height: fit-content;
	padding: 32rem 48rem;
	position: fixed;
	z-index: 9999999;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%) scale(0.1);
	opacity: 0;
	bottom: -600rem;
	transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
	transform-origin: bottom center;
}

.showFormPopup {
	opacity: 1;
	transform: translate(-50%, -50%) scale(1);
	bottom: 0;
}

.ar .formPopup svg {
	right: unset;
	left: 32rem;
}

.formPopup svg {
	position: absolute;
	top: 32rem;
	right: 32rem;
	width: 32rem;
	height: 32rem;
}

.formPopup h3 {
	color: var(--ebc-text-primary);
}

.formPopup h4 {
	margin: 16rem 0 32rem;
	color: var(--ebc-text-secondary);
}

.formPopup input {
	border-radius: var(--ebc-corner-radius-rc16);
	background: var(--ebc-neutral-bg_b);
	margin-bottom: 16rem;
	padding: 13rem 20rem;
	width: 100%;
	color: var(--ebc-text-primary);
	height: 48rem;
}

.formPopup input::placeholder {
	color: rgba(0, 0, 0, 0.48);
}

.formPopup .verify {
	gap: 12rem;
}

.formPopup .verify input {
	width: 300rem;
	margin: 0;
	flex: 1
}

::v-deep .formPopup .verify-img canvas {
	width: 140rem;
	height: 48rem;
}

.formPopup .btn {
	margin-top: 32rem;
	width: 100%;
	padding: 16rem 0;
	background: var(--ebc-brand-secondary-red);
	border-radius: var(--ebc-corner-radius-full);
	color: var(--ebc-text-primary_white);
	box-sizing: border-box;
	cursor: pointer;
	font-size: 16rem;
}

@media screen and (max-width: 996px) {
	::v-deep .formPopup .verify-img canvas {
		width: 280rem;
		height: 96rem;
	}

	.section4 {
		padding: 160rem 0;
	}

	.section4 .container {
		width: 100%;
		height: 100%;
		overflow: hidden;
		max-width: 100%;
	}

	.section4 .danwei {
		font-size: 44rem;
	}

	.section4 #earth-container {
		min-height: 800rem;
	}

	.section4 .container canvas {
		/* width: 400rem !important; */
		/* height: 400rem !important; */
		margin-inline: auto;
	}

	.section4 .marker-dot .wordPart {
		display: block;
		background: none;
		padding: 0;
		border-radius: 0;
		backdrop-filter: none;
		-webkit-backdrop-filter: none;
	}

	.section4 #section4ContactUs svg {
		margin-left: 8rem;
	}

	.section4 .marker-dot .wordPart div:nth-child(2) {
		font-size: 20rem;
	}

	.section4 .marker-dot .transparentDot {
		display: none;
	}

	.section4 .section4Bottom {
		flex-wrap: wrap;
		gap: 0;
		margin-top: 80rem;
		/* position: relative; */
		/* z-index: 99999; */
	}

	.section4 .section4Bottom>div {
		flex: 1 0 50%;
	}
   .section4 .section4Bottom > div:nth-child(n+3) {
    	margin-top: 48rem;
   }

	.en .section4 .section4Bottom .bottom {
		max-width: 340rem;
	}

	.section4 .section4Bottom .bottom {
		max-width: 280rem;
		margin-inline: auto;
	}

	.section4 .mobile .btn {
		/* margin-top: 50rem; */
	}

	.section4 .formPopup {
		width: 100%;
		height: 896rem;
		border-radius: 48rem 48rem 0 0;
		padding: 64rem 32rem 96rem;
		left: 0;
		transform: none;
		top: unset;
		transform-origin: bottom center;
		z-index: -1;
	}

	.section4 .formPopup h3 {
		text-align: left !important;
		padding:0;
	}

	.section4 .formPopup .verify {
		gap: 24rem;
	}

	.section4 .formPopup .verify img {
		width: 280rem !important;
		border-radius: 16rem !important;
	}

	.section4 .formPopup svg {
		width: 48rem;
		height: 48rem;
	}

	.section4 .formPopup h4 {
		margin: 16rem 0 40rem;
	}

	.section4 .formPopup input {
		width: 100%;
		height: 96rem;
		padding: 28rem 32rem;
	}

	.showFormPopup {
		bottom: 0rem;
		z-index: 9999999 !important;
	}

	.formPopup .btn {
		height: 96rem;
		margin-top: 48rem;
		font-size: 32rem;
	}
}

.section5 {
	background-color: #fff;
	padding: 160rem 0;
	position: relative;
	overflow: hidden;
}

.section5 .pc a {
	margin: 80rem auto 0;
	width: fit-content;
	display: block;
}

.section5 .section5NewList a {
	margin: 0;
}

.section5 .bottomPart {}

.section5 h2 {
	color: var(--ebc-text-primary);
}

.section5 h3 {
	color: var(--ebc-text-secondary);
	margin: 12rem 0 80rem;
}


.section5 .news-list {
	transition: transform;
}

.section5 .news-list img {
	width: 368px;
	margin-inline: 16px;
	height: auto;
	margin-bottom: 8rem;
	border-radius: var(--ebc-corner-radius-rc04);
}

.section5 .news-list h3 {
	padding-inline: 20px;
	color: var(--ebc-text-primary);
	margin: 0;
}

@media screen and (max-width: 996px) {
	.section5 {
		padding: 160rem 0;
		overflow: hidden;
	}

	.section5 h2,
	.section5 h3 {
		padding: 0 32rem;
	}

	.section5 h3 {
		margin: 16rem 0 80rem;
	}

	.section5 .news-listm {
		width: 686rem;
		margin-inline: auto;
	}

	.section5 .news-listm img {
		width: 100%;
		height: auto;
		margin-bottom: 16rem;
		border-radius: var(--ebc-corner-radius-rc16);
	}

	.section5 .news-listm h3 {
		margin: 0 0 36rem;
		padding: 0;
		text-align: left !important;
		color: var(--ebc-text-primary);
	}

	.section5 .news-listm .news-li:nth-child(n+4) {
		display: none;
	}

	.section5 .btn {
		margin-top: 80rem;
		justify-content: center;
	}
}

.safeTim {
	color: rgba(0, 0, 0, 0.24);
	text-align: center;
	/* margin-bottom: 24rem; */
	position: relative;
	background-color: #fff;
	padding-bottom: 24rem;
	margin-top: -50rem
}

@media screen and (max-width: 996px) {

	h2,
	h3 {
		max-width: 95vw;
		margin-inline: auto !important;
		text-align: center !important;
	}

	.safeTim {
		padding: 0 2vw 30rem;
	}
}
#noShowmobile,
#noShow{
  opacity: 0;
  pointer-events: none;
}
#noShowmobile{
  display: none;
}
#tbodyContainerM,
.index-section1-list{
  position: relative;
}
.tab5ShowMes{
  display: none;
  color: var(--ebc-text-tertiary);
   font-size: 14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 28rem; 
  position: absolute;
  top:190rem;
}

.tab5 .tab5ShowMes{
  display: block
}
.tab5 .tab5ShowMes a{
  color: var(--ebc-basecolor-active-500);
  cursor: pointer;
}
.tab5 .tab5ShowMes a:hover{
  text-decoration: underline;
}
@media (max-width: 996px) {
.tab5ShowMes{
  font-size: 24rem;
  line-height: 40rem;
  margin:40rem 32rem;
  text-align: left;
  position: static;
  transform: translateX(0);
}
}
</style>